import "./paseolibre.css";

const Libre = () => {
  return (
    <>
      <svg viewBox="0 0 1525.89 808.81">
        <defs>
          <linearGradient
            id="Degradado_sin_nombre"
            x1="763.32"
            y1="120.48"
            x2="763.32"
            y2="811.48"
            gradientTransform="matrix(1, 0, 0, -1, 0, 811.48)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#d8f0fe" />
            <stop offset="0.4" stop-color="#d6effe" />
            <stop offset="0.58" stop-color="#cfecfe" />
            <stop offset="0.71" stop-color="#c2e7fd" />
            <stop offset="0.83" stop-color="#b0e0fd" />
            <stop offset="0.92" stop-color="#99d6fd" />
            <stop offset="1" stop-color="#81cdfc" />
          </linearGradient>
          <clipPath id="clip-path">
            <polygon
              class="cls4-1"
              points="1.75 266.57 1.75 630.46 1366.75 646.12 1366.75 266.57 1.75 266.57"
            />
          </clipPath>
          <clipPath id="clip-path-2">
            <rect class="cls4-1" x="253.75" y="232" width="322" height="465" />
          </clipPath>
        </defs>
        <g id="Capa_2" data-name="Capa 2">
          <g id="Capa_1-2" data-name="Capa 1">
            <g id="fondo">
              <rect class="cls4-2" x="0.75" width="1525.14" height="691" />
            </g>
            <g id="Chimborazo">
              <g class="cls4-3">
                <path
                  class="cls4-4"
                  d="M1160.25,422.27c-2.53-.49-4.72-.8-4.72-.8l-.94-.29L1154,420v1l-.67-.21-2.33-2.32-4.5-3H1145l-3-6h-1.5l-3-1.5-1.5-3-3,3h-1.5l-4.49,3-1.88-.94h-.05l7.92-5,3-3,4.5,4.5,6,1.5Z"
                />
                <polygon
                  class="cls4-5"
                  points="1154.59 421.18 1154.03 421.01 1154.03 419.98 1154.59 421.18"
                />
                <path
                  class="cls4-6"
                  d="M1525.89,622.4l-130.45-55.48h-60L1244,550.43l-46.48-4.5-102-36L1058,526.43l-42-16.5-73.48,28.49-60-4.5-87-24L722,538.41s-27-7.5-31.48-10.49-120,33-120,33-93-15-96-16.49-22.49,30-22.49,30l-64.47,71L.89,646.34.36,556.43l119-46.69,227.23-16.29-20.25,36,99-25.49,25.49-1.5L489.75,480l19.49,6-9,6,51-7.5.73,1,3.77,5,12.64-2.21h0l19.52-3.42h0L615.75,480l46.49,7.5h31.48l66-3,30-9L830.2,480l37.49,4.5,30-9L976,487l23.54,3.46,30.08,1.07,11.91.43,28.49-12,27,12,5.59-7.69,6.4-8.81,8.93,5.68,7.57,4.82H1160l12-4h0l6-2,2.08.54,38.4,10,15-6,24,10.5,57,10.49L1328,498l55.48,28.49s7.5-24,10.5-24,71.28,13.08,73.42,13.49h0Z"
                />
                <polygon
                  class="cls4-7"
                  points="591.73 464.96 570.74 478.45 551.98 485.43 551.25 484.45 500.27 491.95 509.26 485.95 489.77 479.95 450.78 502.44 425.29 503.94 326.33 529.43 346.58 493.45 346.59 493.45 348.07 492.7 418.55 492.7 422.16 490.57 422.89 490.14 416.3 499.45 456.78 494.95 488.27 475.45 509.26 479.95 534.75 466.46 543.75 469.46 565.67 457.13 558.74 466.46 569.24 461.96 566.24 470.96 591.73 464.96"
                />
                <polygon
                  class="cls4-4"
                  points="630.72 427.48 621.72 431.98 630.08 435.16 614.22 442.48 602.23 442.48 575.24 458.96 567.74 455.96 565.67 457.13 543.75 469.46 534.75 466.46 509.26 479.95 488.27 475.45 456.78 494.95 416.3 499.45 422.89 490.14 477.02 458.21 481.52 465.71 490.36 459.71 510.76 455.96 500.27 472.46 519.76 464.96 521.26 446.98 537.75 454.46 548.25 431.98 579.23 432.22 579.24 432.22 583.48 432.73 589.51 427.45 590.23 436.48 621.37 419.36 622.47 419.24 626.97 411.74 634.25 411.74 630.72 427.48"
                />
                <polygon
                  class="cls4-6"
                  points="579.23 432.22 548.25 431.98 537.75 454.46 521.26 446.98 519.76 464.96 500.27 472.46 510.76 455.96 490.36 459.71 523.51 437.23 523.51 443.23 546 428.23 579.23 432.22"
                />
                <polygon
                  class="cls4-6"
                  points="621.37 419.36 590.23 436.48 589.51 427.45 595.48 422.23 621.37 419.36"
                />
                <path
                  class="cls4-8"
                  d="M1467.36,515.93c-2.14-.41-70.47-13.49-73.42-13.49s-10.5,24-10.5,24L1328,498l-13.49,7.49-57-10.49-24-10.5-15,6-38.4-10-17.08-17,21,7.5-3-10.5L1137.53,441l63,22.49-4.5,9,15,9,15-4.5-10.5-13.49L1256,489l-15-24,39,28.49h13.5l-30-24h18l15,16.49-12-7.5,18,19.5H1313l3-6,7.49,3L1307,480l27,16.5L1317.47,480l39,15-7.42-16.79,2.92.29Z"
                />
                <polygon
                  class="cls4-6"
                  points="687.7 392.99 681.7 416.99 660.71 416.99 633.72 433.48 630.08 435.16 621.72 431.98 630.72 427.48 634.25 411.74 635.97 411.74 648.5 399.21 668.2 398.99 687.7 392.99"
                />
                <polygon
                  class="cls4-5"
                  points="770.17 387 777.66 379.5 773.17 378 750.67 395.99 759.67 387 773.17 376.5 776.16 375 780.66 379.5 770.17 387"
                />
                <path
                  class="cls4-9"
                  d="M777.66,343.51l-7.49,9-9,6-1.5-1.5h-3l-1.5,3-13.49,12,9-15v-3l-16.49,10.5,16.56-16.11,19.38-10.88,16.46-8.23c-.45.43-15,14.24-16.46,15.72S777.66,343.51,777.66,343.51Z"
                />
                <path
                  class="cls4-6"
                  d="M768.67,424.47c1.5,0,12,6,12,6l-15-3V435l-16.5,12,15-6-3.54,15-.26.18-27.69,19.26,4.5-12-13.5,15,9-18L719.19,444l-46.44,19.46L689.2,435l-22.45,16.46,9-7.49-27,7.49,4.5-4.49-28.5,13.49,24-4.5L588,484.81h0l-19.52,3.42,47.32-36.77v6L641.21,435l24-7.5-12,15,24-18-3,6,30-19.49-9,10.49,22.5-18,7.49-12-12,9,1.5-6-6,6,3-9L731.18,378l7.5,1.5v6l7.5-1.5-9,7.5,10.49,4.5h-12l1.5,9-27,18,24-9c-.62.48-21,16.48-19.48,16.48s20.39-7.27,21-7.49L722.2,433.48l16.5-4.5-16.5,12,16.5-3,1.5,6,19.49-10.5h-10.5l10.5-7.5-12-1.5L779.16,402l-7.49,12,37.48-24-36,28.49h10.49S767.17,424.47,768.67,424.47Z"
                />
                <polygon
                  class="cls4-5"
                  points="968.09 422.98 968.09 424.48 966.59 424.48 968.09 422.98"
                />
                <polygon
                  class="cls4-5"
                  points="977.09 424.48 974.09 425.98 974.09 424.48 975.59 422.98 977.09 424.48"
                />
                <polygon
                  class="cls4-5"
                  points="1050.56 422.98 1050.56 424.48 1047.57 424.48 1050.56 422.98"
                />
                <polygon
                  class="cls4-9"
                  points="1071.56 407.99 1059.56 410.99 1037.07 409.49 1029.57 406.49 1035.57 404.99 1032.57 401.99 1029.57 401.99 1022.07 395.99 1031.07 397.49 1035.57 387 1034.07 387 1029.57 381 1028.07 385.5 1023.57 382.5 1017.58 376.5 1010.08 381 1013.08 388.5 1007.08 387 1013.08 395.99 1008.58 397.49 1013.08 404.99 987.59 431.98 992.09 424.48 989.09 424.48 998.08 415.49 987.59 415.49 987.59 412.49 975.59 410.99 969.59 413.99 960.6 407.99 971.09 410.99 980.09 403.49 975.59 390 974.09 401.99 971.09 401.99 956.1 387 962.1 384 983.09 376.5 969.59 366 974.09 375 968.09 370.5 965.1 370.5 965.1 364.51 968.09 363.01 968.09 361.51 963.6 360.01 963.6 363.01 957.6 360.01 948.6 361.51 953.1 357.01 953.1 352.51 950.1 352.51 944.1 351.01 947.1 349.51 947.1 346.51 950.1 351.01 954.6 349.51 959.1 354.01 959.1 351.01 963.6 354.01 962.1 351.01 969.59 358.51 969.59 355.51 974.09 361.51 972.59 357.01 978.59 361.51 977.09 358.51 983.09 358.51 975.59 354.01 977.09 352.51 972.59 348.01 978.59 349.51 975.59 346.51 980.09 346.51 975.59 342.01 990.59 349.51 995.08 348.01 998.08 351.01 993.58 351.01 992.09 352.51 984.59 349.51 989.09 355.51 981.59 352.51 993.58 367.5 995.08 361.51 999.58 357.01 999.58 364.51 1004.08 355.51 1011.58 357.01 1011.58 354.01 1005.58 352.51 1011.58 351.01 1010.08 349.51 1005.58 348.01 1005.9 345.01 1010.08 345.01 1017.29 343.57 1014.58 348.01 1016.08 352.51 1014.58 357.01 1014.58 364.51 1017.58 358.51 1019.08 363.01 1016.08 372 1025.07 363.01 1020.57 373.5 1022.07 375 1025.07 372 1023.57 378 1026.57 381 1032.57 375 1034.07 381 1037.07 384 1038.57 381 1038.57 376.5 1041.57 375 1041.57 370.5 1038.57 369 1041.57 364.51 1038.57 360.01 1034.07 360.01 1034.07 357.01 1028.07 357.01 1038.57 351.01 1037.07 355.51 1040.07 354.01 1044.57 355.51 1046.07 363.01 1053.56 378 1059.56 381 1056.56 387 1056.56 382.5 1050.56 379.5 1050.56 387 1047.57 382.5 1049.06 376.5 1044.57 367.5 1044.57 378 1041.57 384 1037.07 392.99 1043.07 395.99 1043.07 390 1049.06 397.49 1052.06 390 1053.56 400.49 1056.56 392.99 1056.56 400.49 1061.06 403.49 1065.56 395.99 1067.06 404.99 1071.56 407.99"
                />
                <polygon
                  class="cls4-5"
                  points="1113.54 460.46 1109.04 458.96 1112.04 455.96 1113.54 460.46"
                />
                <polygon
                  class="cls4-5"
                  points="1190.01 448.46 1184.02 445.48 1187.01 443.98 1190.01 448.46"
                />
                <path
                  class="cls4-10"
                  d="M1525.89,622.4H297.75c7.61,0,159-40.48,159-40.48l10.5,6,39-12s9,10.49,12,9,7.5-15,18-9,150,27,150,27,40.48-1.5,42-1.5,70.48-10.5,70.48-10.5h63l129,15s97.46,6,102,6,112.46,1.5,112.46,1.5,117-15,120-15h63Z"
                />
                <path
                  class="cls4-11"
                  d="M1525.89,622.4l-138-24h-63c-3,0-120,15-120,15s-108-1.5-112.46-1.5-102-6-102-6l-129-15h-63s-69,10.5-70.48,10.5-42,1.5-42,1.5-139.45-21-150-27-15,7.5-18,9-12-9-12-9l-39,12-10.5-6s-151.11,40.5-158.7,40.5H159.89l227.92-55.48,64.47,7.5s19.5-31.49,22.49-30,96,16.49,96,16.49,115.46-36,120-33,31.48,10.49,31.48,10.49l73.48-28.49,87,24,60,4.5,73.48-28.49,42,16.5,37.49-16.5,102,36,46.48,4.5,91.47,16.49h60Z"
                />
                <line
                  class="cls4-12"
                  x1="424.39"
                  y1="488.02"
                  x2="422.89"
                  y2="490.14"
                />
                <line
                  class="cls4-12"
                  x1="551.98"
                  y1="485.43"
                  x2="550.39"
                  y2="486.02"
                />
                <line
                  class="cls4-12"
                  x1="750.81"
                  y1="348.38"
                  x2="750.79"
                  y2="348.4"
                />
                <path
                  class="cls4-7"
                  d="M1002.58,463.46,983.09,480,976,487l-78.42-11.54-30,9L830.14,480l-40.48-4.5-30,9-66,3H662.21L615.75,480,588,484.86C589.66,484,648.75,456,648.75,456l-24,4.5L653.21,447l-4.5,4.49,27-7.49-9,7.49L689.2,435l-16.45,28.46L719.19,444l13.49,16.49-9,18,13.5-15-4.5,12,27.69-19.26.26-.18,6.54-4.55-7.5,15,7.5-1.5,3,7.5,1.5-15,13.49-15,10.5,7.49-13.5,1.5-4.5,18,13.5-12-7.5,12,15-6,24,7.5-24-15,42,19.49,39-33-15,21,16.5-15-4.5,25.5,34.49-21-15,19.5L930.61,438l19.49,9-21,3-15,13.5L927.61,477s28.49-7.49,28.49-6,9,13.49,9,13.49l27-22.49-6-1.5L972.59,471l6-15-10.5,7.5,1.5-15-13.49-12Z"
                />
                <path
                  class="cls4-7"
                  d="M1102.64,484.26l-5.59,7.74-27-12-28.49,12-11.91-.43-24.07-22c.6.34,21,12,19.48,10.48s-21.84-30.56-22.47-31.47l9,7.48-6-10.49,27,25.49,3-15,24-10.49,10.5,27,10.49-4.5-1.5,6,16.5,9V471l-12-13.5,16.5,13.5Z"
                />
                <line
                  class="cls4-12"
                  x1="1002.6"
                  y1="448.48"
                  x2="1002.58"
                  y2="448.46"
                />
                <line
                  class="cls4-12"
                  x1="1005.59"
                  y1="469.47"
                  x2="1005.58"
                  y2="469.46"
                />
                <polygon
                  class="cls4-7"
                  points="1172 481.96 1160.02 485.95 1125.54 485.95 1117.97 481.13 1115.04 473.96 1125.54 476.95 1110.54 463.46 1137.53 481.45 1151.03 481.45 1142.03 470.96 1172 481.96"
                />
                <line
                  class="cls4-12"
                  x1="760.63"
                  y1="456.01"
                  x2="760.39"
                  y2="457.02"
                />
                <path class="cls4-5" d="M735.68,423h0" />
                <path class="cls4-5" d="M734.18,414h0" />
                <line
                  class="cls4-12"
                  x1="568.39"
                  y1="488.24"
                  x2="567.39"
                  y2="489.02"
                />
                <polygon
                  class="cls4-4"
                  points="806.15 370.5 809.15 373.5 803.15 375 791.16 379.5 794.16 372 789.66 372 803.15 357.01 797.16 369 798.66 369 795.66 375 800.16 373.5 803.15 367.5 809.15 367.5 810.65 370.5 806.15 370.5"
                />
                <polygon
                  class="cls4-4"
                  points="833.14 370.5 822.65 373.5 827.15 373.5 806.15 385.5 782.16 403.49 785.16 395.99 771.67 401.99 779.16 388.5 786.66 392.99 791.16 390 783.66 387 789.66 385.5 797.16 385.5 806.15 378 810.65 378 819.65 370.5 815.15 370.5 851.14 345.01 824.15 370.5 833.14 370.5"
                />
                <polygon
                  class="cls4-4"
                  points="752.17 390 753.67 384 750.67 384 753.67 381 756.67 385.5 752.17 390"
                />
                <polygon
                  class="cls4-4"
                  points="770.17 387 777.66 379.5 773.17 378 750.67 395.99 759.67 387 773.17 376.5 776.16 375 780.66 379.5 770.17 387"
                />
                <polygon
                  class="cls4-13"
                  points="864.63 416.99 855.64 428.98 855.64 430.48 834.64 430.48 830.14 433.48 821.15 433.48 822.65 434.98 801.66 448.46 809.15 436.48 801.66 437.98 806.15 434.98 795.66 425.98 798.66 434.98 786.66 421.48 788.16 415.49 795.66 416.99 807.65 398.99 798.66 419.98 810.65 410.99 806.15 427.48 821.15 418.49 809.15 431.98 828.65 424.48 816.65 433.48 827.15 430.48 846.64 427.48 837.64 424.48 848.14 419.98 837.64 418.49 855.64 416.99 845.14 412.49 857.13 407.99 864.63 416.99"
                />
                <polygon
                  class="cls4-13"
                  points="936.61 415.49 918.61 430.48 902.12 440.98 888.62 445.48 893.12 439.48 888.62 439.48 884.12 440.98 885.62 436.48 881.13 436.48 839.14 469.46 842.14 461.96 825.65 463.46 845.14 454.46 839.14 445.48 851.14 448.46 851.14 439.48 858.63 443.98 857.13 436.48 864.63 440.98 861.63 431.98 872.13 439.48 873.63 428.98 879.63 433.48 884.12 428.98 879.63 427.48 900.62 416.99 890.12 431.98 900.62 427.48 897.62 436.48 905.12 433.48 924.61 418.49 927.61 410.99 927.61 382.5 936.61 415.49"
                />
                <polygon
                  class="cls4-4"
                  points="842.14 375 846.64 375 843.64 378 836.14 384 840.64 367.5 846.64 366 842.14 369 842.14 375"
                />
                <polygon
                  class="cls4-4"
                  points="843.64 401.99 846.64 401.99 843.64 404.99 839.14 403.49 836.14 403.49 825.65 404.99 834.64 401.99 827.15 400.49 828.65 398.99 825.65 398.99 816.65 388.5 822.65 381 824.15 379.5 828.65 384 827.15 378 831.64 384 828.65 385.5 828.65 387 824.15 382.5 819.65 388.5 825.65 395.99 831.64 391.5 831.64 397.49 834.64 394.49 834.64 390 839.14 394.49 840.64 391.5 840.64 394.49 843.64 392.99 842.14 395.99 834.64 397.49 834.64 398.99 842.14 398.99 848.14 394.49 843.64 401.99"
                />
                <polygon
                  class="cls4-4"
                  points="950.1 391.5 941.1 392.99 947.1 385.5 945.6 391.5 947.1 390 950.1 391.5"
                />
                <polygon
                  class="cls4-4"
                  points="968.09 419.98 963.6 416.99 960.6 418.49 954.6 419.98 959.1 421.48 953.1 427.48 954.6 422.98 948.6 422.98 951.6 419.98 950.1 419.98 956.1 416.99 963.6 413.99 968.09 419.98"
                />
                <polygon
                  class="cls4-4"
                  points="975.59 436.48 975.59 433.48 968.09 433.48 968.09 428.98 971.09 431.98 974.09 430.48 978.59 431.98 981.59 434.98 975.59 436.48"
                />
                <polygon
                  class="cls4-4"
                  points="980.09 415.49 980.09 418.49 975.59 416.99 980.09 415.49"
                />
                <polygon
                  class="cls4-9"
                  points="1153.36 420.8 1136.03 415.49 1127.04 410.99 1131.53 407.99 1133.03 407.99 1136.03 404.99 1137.53 407.99 1140.53 409.49 1142.03 409.49 1145.03 415.49 1146.53 415.49 1151.03 418.49 1153.36 420.8"
                />
                <polygon
                  class="cls4-14"
                  points="1154.59 421.18 1154.03 421.01 1154.03 419.98 1154.59 421.18"
                />
                <polygon
                  class="cls4-4"
                  points="945.6 425.98 942.6 425.98 944.1 424.48 945.6 425.98"
                />
                <polygon
                  class="cls4-4"
                  points="950.1 427.48 947.1 430.48 947.1 428.98 950.1 427.48"
                />
                <polygon
                  class="cls4-4"
                  points="968.09 422.98 968.09 424.48 966.59 424.48 968.09 422.98"
                />
                <polygon
                  class="cls4-4"
                  points="977.09 424.48 974.09 425.98 974.09 424.48 975.59 422.98 977.09 424.48"
                />
                <polygon
                  class="cls4-4"
                  points="1041.57 421.48 1041.57 424.48 1037.07 421.48 1037.07 419.98 1041.57 421.48"
                />
                <polygon
                  class="cls4-4"
                  points="1058.06 422.98 1056.56 424.48 1055.06 422.98 1055.06 419.98 1058.06 422.98"
                />
                <polygon
                  class="cls4-4"
                  points="1050.56 422.98 1050.56 424.48 1047.57 424.48 1050.56 422.98"
                />
                <polygon
                  class="cls4-4"
                  points="1113.54 448.46 1113.54 451.46 1110.54 448.46 1112.04 446.98 1113.54 448.46"
                />
                <path
                  class="cls4-15"
                  d="M1317.47,480l39,15-7.42-16.79L1337,477l-10.5-3-12-9-13.5,1.5-6-4.5-12,4.5-15-4.5-15-7.5L1232,444l-12,1.5-13.49-7.5L1184,435s-15-9-16.5-10.5c-.81-.81-4.28-1.63-7.27-2.2-2.53-.49-4.72-.8-4.72-.8l-.94-.29-.56-.17-.67-.21L1136,415.52l-9-4.5-1.88-.94h0L1094,394.55l-37.49-30-15-15-16.5-7.5-7.78,1.56-2.71,4.44,1.5,4.5-1.5,4.5v7.5l3-6,1.5,4.5-3,9,9-9-4.5,10.49,1.5,1.5,3-3-1.5,6,3,3,6-6,1.5,6,3,3,1.5-3v-4.5l3-1.49v-4.5l-3-1.5,3-4.49-3-4.5H1034v-3h-6l10.5-6-1.5,4.5,3-1.5,4.5,1.5,1.5,7.5,7.49,15,6,3-3,6v-4.5l-6-3V387l-3-4.5,1.49-6-4.49-9V378l-3,6-4.5,9,6,3v-6l6,7.49,3-7.49,1.5,10.49,3-7.5v7.5l4.5,3,4.5-7.5,1.5,9,4.5,3-12,3-22.49-1.5-7.5-3,6-1.5-3-3h-3l-7.5-6,9,1.5,4.5-10.49H1034l-4.5-6-1.5,4.5-4.5-3-6-6L1010,381l3,7.5-6-1.5,6,9-4.5,1.5,4.5,7.5-25.49,27,4.5-7.5h-3l9-9H987.59v-3l-12-1.5-6,3-9-6,10.49,3,9-7.5L975.59,390l-1.5,12h-3l-15-15,6-3,21-7.5L969.59,366l4.5,9-6-4.5h-3v-6l3-1.5v-1.5L963.6,360v3l-6-3-9,1.5,4.5-4.5v-4.5h-3l-6-1.5,3-1.5v-3l3,4.5,4.5-1.5,4.5,4.5v-3l4.5,3-1.5-3,7.49,7.5v-3l4.5,6-1.5-4.5,6,4.5-1.5-3h6l-7.5-4.5,1.5-1.5-4.5-4.5,6,1.5-3-3h4.5l-4.5-4.5,15,7.5,4.49-1.5,3,3h-4.5l-1.49,1.5-7.5-3,4.5,6-7.5-3,12,15,1.5-6,4.5-4.5v7.5l4.5-9,7.5,1.5v-3l-6-1.5,6-1.5-1.5-1.5-4.5-1.5.32-3h-6.32l-9-9-16.5-7.5H954.6l-10.5,3-18-13.5-37.49-13.49-12-7.5h-45L802.75,308.8l1.9,9.22,9-4.5,1.5,6,7.5-9h3l3-7.5h6l3-3,6,6,1.5-1.5,10.5-6,3,10.5-4.49,4.49,6,4.5,3,1.5,1.5-4.5-6-13.49,6-3,16.5,10.5-3,4.49,4.5,6-9,4.5,7.5,7.5-6,1.5,3,6-4.5-1.49,3,7.49-10.5-9-9,6,9-10.49,10.5-1.5-6-4.5,1.5-4.5,7.5-3-4.5-3,3-4.49-10.5-7.5,1.5,6-6-6,3,9,3,4.5-4.5,6h-4.5l-9-9,3-3-1.5-3,3-1.5-1.5-4.5-7.5,4.5,3,3-1.5,4.49,1.5,3,4.5,4.5-4.5,1.5,4.5,7.5h-4.5l7.49,6-7.49-1.5-4.5,7.49V330l-9,3,6-10.5-6-3,6-3V309l-4.5-6-1.5,3-6-1.5-4.49,12,3,10.5-3,3v7.5L815.15,357l6-21-4.5-6,4.5-4.5,1.5-12-9,10.5-1.5-7.5-9,4.5-1.49-6-1.5,3-3.61-6.7-5.39,2.2-3,15-1.52.76h0c-.45.43-15,14.24-16.46,15.72s7.49-1.5,7.49-1.5l-7.49,9-9,6-1.5-1.5h-3l-1.5,3-13.49,12,9-15v-3l-16.49,10.5,16.55-16.08-66,37.09-33,10.51-3.21,3.22,19.7-.22,19.5-6-6,24h-21l-27,16.49-3.64,1.68-15.86,7.32h-12l-27,16.49-7.5-3-2.07,1.17-6.93,9.31,10.5-4.5-3,9,25.5-6-21,13.49-18.76,7,3.77,5,12.64-2.21h0l47.35-36.82v6L641.21,435l24-7.5-12,15,24-18-3,6,30-19.49-9,10.49,22.5-18,7.49-12-12,9,1.5-6-6,6,3-9L731.18,378l7.5,1.5v6l7.5-1.5-9,7.5,10.49,4.5h-12l1.5,9-27,18,24-9c-.62.48-21,16.48-19.48,16.48s20.39-7.27,21-7.49L722.2,433.48l16.5-4.5-16.5,12,16.5-3,1.5,6,19.49-10.5h-10.5l10.5-7.5-12-1.5L779.16,402l-7.49,12,37.48-24-36,28.49h10.49s-16.49,6-15,6,12,6,12,6l-15-3V435l-16.5,12,15-6-3.54,15,6.54-4.55-7.5,15,7.5-1.5,3,7.5,1.5-15,13.49-15,10.5,7.49-13.5,1.5-4.5,18,13.5-12-7.5,12,15-6,24,7.5-24-15,42,19.49,39-33-15,21,16.5-15-4.5,25.5,34.49-21-15,19.5L930.61,438l19.49,9-21,3-15,13.5L927.61,477s28.49-7.49,28.49-6,9,13.49,9,13.49l27-22.49-6-1.5L972.59,471l6-15-10.5,7.5,1.5-15-13.49-12,46.48,27L983.09,480,976,487l23.54,3.46,30.08,1.07-24.07-22c.6.34,21,12,19.48,10.48s-21.84-30.56-22.47-31.47l9,7.48-6-10.49,27,25.49,3-15,24-10.49,10.5,27,10.49-4.5-1.5,6,16.5,9V471l-12-13.5,16.5,13.5,2.59,13.3,6.4-8.81,8.93,5.68-2.93-7.17,10.5,3-15-13.49,27,18h13.5l-9-10.49,30,11h0l6-2,2.08.54-17.08-17,21,7.5-3-10.5L1137.53,441l63,22.49-4.5,9,15,9,15-4.5-10.5-13.49L1256,489l-15-24,39,28.49h13.5l-30-24h18l15,16.49-12-7.5,18,19.5H1313l3-6,7.49,3L1307,480l27,16.5Zm-293.9-126-4.49-1.5,1.49-1.5h-1.49l1.49-1.5v-3l4.5,4.5,1.5-1.5-1.5-1.5,3,1.5v3l1.5,1.5Zm-57-4.5,1.5,1.5h-1.5l-7.49-6Zm-18-16.49,1.5,6,6,6v3l-9-6v-3l-1.5-1.49ZM710.19,387v-3l-4.5,6,1.5,3-3-1.49-10.5,6h6l-3,4.5,7.5-4.5-6,6,6-1.5-13.44,9,1.5-4.5-4.5,1.5,6-6-4.49-1.5,1.49-4.5,12-7.49,3-3-9,1.5,4.5-3h3v-4.5l3,3,3-3,4.5,3Zm19.49-10.5h-4.5l3-4.49,3,1.5Zm250.41,39v3l-4.5-1.5Zm-6,9,1.5-1.5,1.5,1.5-3,1.5Zm-15-60,3,3V372l-3,3,4.5-1.5v6l-3-1.5-3,4.5-1.5-3h-3l6-9v-3l-7.5-3Zm-3,30-3,6-4.5,1.5Zm-10.5-30,1.5,1.49h-4.5Zm-84-16.5v-3l1.5,1.5,1.5-1.5,3,3h-3l3,3-3,1.5-6-4.5Zm-6,13.5,3,10.49h4.5l3,6s3-7.49,3-9v10.49l13.5,3-1.5-3,3-1.5-9-7.49,13.49,3-1.5-3h4.5l-4.5-6,7.5-3-12-1.5-3-12,4.49-3-4.49-9,13.49,3,12,10.5-1.5-3,7.5,1.5-7.5-9,10.49,7.5-3-4.5,6,1.5,3-7.49h21l-4.49,12h-4.5l6,10.5-3-3-1.5,4.5-4.5,19.48-3-16.48-4.5-6-4.5,18-15,19.48-6-1.5-25.49,24,7.5-12-12-12,9,4.5L885.62,387l-7.49-3v6l-4.5-3-6-1.5v3l-7.5-1.5-4.49,3h-12l7.5-6,3,1.5,4.49-1.5,4.5-3-7.49-4.5,3,4.5-10.49-1.5,4.5-6-3-1.5,1.5-7.49s1.5,4.49,1.5,6,3-9,3-9Zm87,10.49H935.1l1.5-1.5h3l1.5-1.5Zm-96,30-3,3-4.5-1.5h-3L825.65,405l9-3-7.49-1.5,1.5-1.5h-3l-9-10.49,6-7.5,1.5-1.5,4.5,4.5-1.5-6,4.49,6-3,1.5V387l-4.5-4.5-4.5,6,6,7.49,6-4.49v6l3-3V390l4.5,4.49,1.5-3v3l3-1.5-1.5,3-7.5,1.5V399h7.5l6-4.5-4.5,7.5Zm0-27-3,3-7.5,6,4.5-16.49,6-1.5-4.5,3v6Zm-36-4.5h-4.5l3,3-6,1.5-12,4.49,3-7.49h-4.5l13.49-15-6,12h1.5l-3,6,4.5-1.5,3-6h6Zm-27,0,7.5-12-1.5-7.5,4.5,3,6-6-3-4.5,4.5,1.5v-6l6,6Zm-12-6h-3l7.49-12-1.5-1.5h4.5l16.5-12-7.5-3,4.5-9v-7.5l4.5,6,6-1.5,3,10.5-4.49,3-21,16.49-6,9L755.1,379.46Zm-18,16.48,3,4.5-4.5,4.5,1.5-6h-3Zm19.5-3-22.5,18,9-9,13.5-10.5,3-1.49,4.5,4.49L770.17,387l7.49-7.5Zm33,7.5-24,18,3-7.5-13.49,6,7.49-13.49,7.5,4.49,4.5-3-7.5-3,6-1.5h7.5l9-7.5h4.5l9-7.49h-4.5l36-25.49-27,25.49h9l-10.49,3h4.5Zm-4.49,63,7.49-12L801.6,438l4.49-3-10.49-9,3,9-12-13.5,1.5-6,7.5,1.5,12-18-9,21,12-9-4.5,16.49,15-9-12,13.54,19.5-7.5-12,9,10.5-3,19.49-3-9-3,10.5-4.5-10.5-1.49,18-1.5-10.5-4.5,12-4.5,7.5,9-9,12v1.5h-21l-4.5,3h-9l1.5,1.5Zm117-18L902.12,441l-13.5,4.5,4.5-6h-4.5l-4.5,1.5,1.5-4.5h-4.49l-42,33,3-7.5-16.49,1.5,19.49-9-6-9,12,3v-9l7.49,4.5-1.5-7.5,7.5,4.5-3-9,10.5,7.5,1.5-10.5,6,4.5,4.49-4.5-4.49-1.5,21-10.49-10.5,15,10.5-4.5-3,9,7.5-3,19.49-15,3-7.5V382.49l9,33Zm28.49-45-1.5,6,1.5-1.5,3,1.5-9,1.49ZM942.6,426l1.5-1.5,1.5,1.5Zm4.5,4.5V429l3-1.5Zm13.5-12-6,1.49,4.5,1.5-6,6,1.5-4.5h-6l3-3h-1.5l6-3,7.5-3,4.49,6-4.49-3Zm7.49,4.49v1.5h-1.5Zm7.5,13.5v-3h-7.5V429l3,3,3-1.5,4.5,1.5,3,3Zm42-19.49-3-3,1.5-1.5,1.5,1.5Zm9-9-6-1.5-3,1.5v-1.5l3-1.5v-4.5l1.5,3,3,3,1.5-1.5Zm10.5,12,4.5,1.5v3l-4.5-3Zm4.5,24-6,1.5,4.5-6h3Zm9-19.5h-3l3-1.5Zm4.5,7.5-3-1.5V429h3Zm1.5-7.5-1.5-1.5v-3l3,3Zm43.46-16.5h-3v3l-7.5-7.5Zm-22.5-21,10.5,6,4.5,3-12-4.49-9-4.5-3-7.5Zm-9,55.48v-6l-3-6,6,4.5,1.5,4.5Zm4.5-10.5v-4.5l3,4.5Zm-4.5-37.49V390l4.5,6,3,4.5Zm30,55.48-10.5,1.5v-3l1.5-7.49,1.5,4.5,3,1.5,7.5-10.5-3-3-6,6,4.5-10.5h-6l-12-18v-3h4.5l-1.5-1.5h1.5l1.5-1.5v1.5l3,3-4.5,1.5,3,3,3-3,6,7.5,3,4.49,3-3,6,3h4.5v7.5Zm10.49,9,3-3,1.5,4.5Zm4.5-7.5-3-3L1112,447l1.5,1.49ZM1112,414l-3-4.5,7.5,3,1.5,4.5Zm72,31.49,3-1.5,3,4.49Zm43.48,6L1223,450l4.5-1.5,4.5,3Zm27,10.5-3-1.5h6l3,3Zm46.48,9h-6l-4.49-1.5,3-1.5,3-1.5,4.5,1.5Z"
                />
                <polygon
                  class="cls4-4"
                  points="1118.04 416.99 1112.04 413.99 1109.04 409.49 1116.54 412.49 1118.04 416.99"
                />
                <polygon
                  class="cls4-4"
                  points="1100.05 407.99 1097.05 407.99 1097.05 410.99 1089.55 403.49 1100.05 407.99"
                />
                <polygon
                  class="cls4-9"
                  points="1112.04 422.98 1112.04 430.48 1098.55 449.96 1088.05 451.46 1088.05 448.46 1089.55 440.98 1091.05 445.48 1094.05 446.98 1101.55 436.48 1098.55 433.48 1092.55 439.48 1097.05 428.98 1091.05 428.98 1079.05 410.99 1079.05 407.99 1083.55 407.99 1082.05 406.49 1083.55 406.49 1085.05 404.99 1085.05 406.49 1088.05 409.49 1083.55 410.99 1086.55 413.99 1089.55 410.99 1095.55 418.49 1098.55 422.98 1101.55 419.98 1107.54 422.98 1112.04 422.98"
                />
                <polygon
                  class="cls4-4"
                  points="1076.05 431.98 1073.06 431.98 1073.06 427.48 1076.05 431.98"
                />
                <polygon
                  class="cls4-4"
                  points="1068.56 442.48 1068.56 436.48 1065.56 430.48 1071.56 434.98 1073.06 439.48 1068.56 442.48"
                />
                <polygon
                  class="cls4-4"
                  points="1055.06 428.98 1055.06 431.98 1052.06 430.48 1052.06 428.98 1055.06 428.98"
                />
                <polygon
                  class="cls4-4"
                  points="1043.07 439.48 1041.57 443.98 1035.57 445.48 1040.07 439.48 1043.07 439.48"
                />
                <polygon
                  class="cls4-4"
                  points="1026.57 404.99 1026.57 407.99 1020.57 406.49 1017.58 407.99 1017.58 406.49 1020.57 404.99 1020.57 400.49 1022.07 403.49 1025.07 406.49 1026.57 404.99"
                />
                <polygon
                  class="cls4-4"
                  points="1017.58 413.99 1017.58 416.99 1014.58 413.99 1016.08 412.49 1017.58 413.99"
                />
                <polygon
                  class="cls4-4"
                  points="1092.55 395.99 1080.55 391.5 1071.56 387 1068.56 379.5 1077.55 387 1088.05 392.99 1092.55 395.99"
                />
                <polygon
                  class="cls4-4"
                  points="1076.05 400.49 1068.56 394.49 1068.56 390 1073.06 395.99 1076.05 400.49"
                />
                <polygon
                  class="cls4-4"
                  points="1029.57 354.01 1023.57 354.01 1019.08 352.51 1020.57 351.01 1019.08 351.01 1020.57 349.51 1020.57 346.51 1025.07 351.01 1026.57 349.51 1025.07 348.01 1028.07 349.51 1028.07 352.51 1029.57 354.01"
                />
                <polygon
                  class="cls4-4"
                  points="968.09 351.01 966.59 351.01 959.1 345.01 966.59 349.51 968.09 351.01"
                />
                <polygon
                  class="cls4-4"
                  points="956.1 394.49 953.1 400.49 948.6 401.99 956.1 394.49"
                />
                <polygon
                  class="cls4-4"
                  points="947.1 366 942.6 366 945.6 364.51 947.1 366"
                />
                <polygon
                  class="cls4-4"
                  points="942.6 372 935.11 372 936.61 370.5 939.6 370.5 941.1 369 942.6 372"
                />
                <polygon
                  class="cls4-4"
                  points="963.6 373.5 963.6 379.5 960.6 378 957.6 382.5 956.1 379.5 953.1 379.5 959.1 370.5 959.1 367.5 951.6 364.51 959.1 364.51 962.1 367.5 962.1 372 959.1 375 963.6 373.5"
                />
                <polygon
                  class="cls4-4"
                  points="710.19 387 710.19 384 705.69 390 707.19 392.99 704.19 391.5 693.69 397.49 699.69 397.49 696.69 401.99 704.19 397.49 698.19 403.49 704.19 401.99 690.7 410.99 692.2 406.49 687.7 407.99 693.69 401.99 689.2 400.49 690.7 395.99 702.69 388.5 705.69 385.5 696.69 387 701.19 384 704.19 384 704.19 379.5 707.19 382.5 710.19 379.5 714.69 382.5 710.19 387"
                />
                <polygon
                  class="cls4-4"
                  points="731.18 373.5 729.68 376.5 725.18 376.5 728.18 372 731.18 373.5"
                />
                <polygon
                  class="cls4-4"
                  points="881.13 331.52 875.13 333.02 878.13 339.01 873.63 337.52 876.63 345.01 866.13 336.02 857.13 342.01 866.13 331.52 876.63 330.02 870.63 325.52 872.13 321.02 879.63 318.02 875.13 315.02 878.13 310.53 867.63 303.03 869.13 309.03 863.13 303.03 866.13 312.02 869.13 316.52 864.63 322.52 860.13 322.52 851.14 313.52 854.14 310.53 852.64 307.53 855.64 306.03 854.14 301.53 846.64 306.03 849.64 309.03 848.14 313.52 849.64 316.52 854.14 321.02 849.64 322.52 854.14 330.02 849.64 330.02 857.13 336.02 849.64 334.52 845.14 342.01 845.14 330.02 836.14 333.02 842.14 322.52 836.14 319.52 842.14 316.52 842.14 309.03 837.64 303.03 836.14 306.03 830.14 304.53 825.65 316.52 828.65 327.02 825.65 330.02 825.65 337.52 815.15 357.01 821.15 336.02 816.65 330.02 821.15 325.52 822.65 313.52 813.65 324.02 812.15 316.52 803.15 321.02 801.66 315.02 800.16 318.02 796.55 311.32 802.75 308.8 804.65 318.02 813.65 313.52 815.15 319.52 822.65 310.53 825.65 310.53 828.65 303.03 834.64 303.03 837.64 300.03 843.64 306.03 845.14 304.53 855.64 298.53 858.63 309.03 854.14 313.52 860.13 318.02 863.13 319.52 864.63 315.02 858.63 301.53 864.63 298.53 881.13 309.03 878.13 313.52 882.63 319.52 873.63 324.02 881.13 331.52"
                />
                <polygon
                  class="cls4-4"
                  points="864.63 348.01 867.63 351.01 864.63 352.51 858.63 348.01 861.63 348.01 861.63 345.01 863.13 346.51 864.63 345.01 867.63 348.01 864.63 348.01"
                />
                <polygon
                  class="cls4-4"
                  points="783.66 370.5 791.16 358.51 789.66 351.01 794.16 354.01 800.16 348.01 797.16 343.51 801.66 345.01 801.66 339.01 807.65 345.01 783.66 370.5"
                />
                <polygon
                  class="cls4-9"
                  points="806.15 334.52 801.66 337.52 780.66 354.01 774.66 363.01 755.17 379.5 771.67 364.51 768.67 364.51 776.16 352.51 774.66 351.01 779.16 351.01 795.66 339.01 788.16 336.02 792.66 327.02 792.66 319.52 797.16 325.52 803.15 324.02 806.15 334.52"
                />
                <path
                  class="cls4-9"
                  d="M932.11,348l6,10.5-3-3-1.5,4.5-4.5,19.48-3-16.48-4.5-6-4.5,18-15,19.48-6-1.5-25.49,24,7.5-12-12-12,9,4.5L885.62,387l-7.49-3v6l-4.5-3-6-1.5v3l-7.5-1.5-4.49,3h-12l7.5-6,3,1.5,4.49-1.5,4.5-3-7.49-4.5,3,4.5-10.49-1.5,4.5-6-3-1.5,1.5-7.49s1.5,4.49,1.5,6,3-9,3-9l3,10.49h4.5l3,6s3-7.49,3-9v10.49l13.5,3-1.5-3,3-1.5-9-7.49,13.49,3-1.5-3h4.5l-4.5-6,7.5-3-12-1.5-3-12,4.49-3-4.49-9,13.49,3,12,10.5-1.5-3,7.5,1.5-7.5-9,10.49,7.5-3-4.5,6,1.5,3-7.49h21l-4.49,12Z"
                />
                <polygon
                  class="cls4-4"
                  points="956.1 345.01 956.1 348.01 947.1 342.01 947.1 339.01 945.6 337.52 948.6 333.02 950.1 339.01 956.1 345.01"
                />
                <polygon
                  class="cls4-4"
                  points="1113.54 460.46 1109.04 458.96 1112.04 455.96 1113.54 460.46"
                />
                <polygon
                  class="cls4-4"
                  points="1190.01 448.46 1184.02 445.48 1187.01 443.98 1190.01 448.46"
                />
                <polygon
                  class="cls4-4"
                  points="1232 451.46 1227.5 451.46 1223 449.96 1227.5 448.46 1232 451.46"
                />
                <polygon
                  class="cls4-4"
                  points="1260.49 463.46 1254.49 461.96 1251.49 460.46 1257.49 460.46 1260.49 463.46"
                />
                <polygon
                  class="cls4-4"
                  points="1300.97 467.96 1300.97 470.96 1294.97 470.96 1290.48 469.46 1293.48 467.96 1296.47 466.46 1300.97 467.96"
                />
              </g>
            </g>
            <g id="calle_cas_pequeña" data-name="calle cas pequeña">
              <polygon
                class="cls4-16"
                points="527.94 604.78 174.08 604.78 238.82 545.55 527.94 545.55 527.94 604.78"
              />
              <polygon
                class="cls4-17"
                points="453.15 604.78 1151.54 597.17 1177.61 614.38 492.22 619.19 453.15 604.78"
              />
              <path
                class="cls4-18"
                d="M526.27,507.53v44.82l-286.89-5.6H188V520.34l.65-.25h0c.62,1.19,1.46,2.67,1.73,3.4a13.55,13.55,0,0,1,.83-4.39,6.06,6.06,0,0,1,3.65-3.59c2.33-.89,5.13-.59,7.81-.77h0l.71-.07a12.86,12.86,0,0,0,7-2.84A8,8,0,0,0,212,510a3,3,0,0,1,1.56-1.56,4.26,4.26,0,0,1,2.07.07l2.42.46,5.29,1c-.22-1.22,1.57-2.39,3.23-2.12a4.66,4.66,0,0,1-.13-2,5.41,5.41,0,0,1,1.4-2.95c1-.21,1.79.58,2.36,1.21a2.23,2.23,0,0,0,.27.26h0c.62.51,1.64.88,2.23.41a1.26,1.26,0,0,0,.38-.78,4.15,4.15,0,0,1,.22-.68c1.12-2.6,6.33-3.71,10.42-3.78h.67c.1-.12.21-.24.32-.35a11.29,11.29,0,0,1,9.92-2.39,1.63,1.63,0,0,1-.27-1c.19-1.81,3.89-3.2,6.8-2.92a9.61,9.61,0,0,1,1.3.16c3,.46,6.07,1.4,8.93.68a3.26,3.26,0,0,0,1.61-.82c.73-.88,0-1.81-.83-2.75a9.42,9.42,0,0,1-1-1.3c-1.51-2.72,2.78-5.49,6.84-5.68s7.95,1.14,12,1.54a8.18,8.18,0,0,1,3.35.74,8,8,0,0,1,1.54,1.74,6.82,6.82,0,0,0,7.16,1.12,2.52,2.52,0,0,0,.2.66c1,2.32,5.17,3.4,8.64,4.07,3.79.74,8.31,2.3,8.17,5.11a11.42,11.42,0,0,0,5.45,0c.55,1,1.12,1.9,1.65,2.85l2.82-4.65,6.9.6a4,4,0,0,0,2.4-.28c.88-.58.52-1.59.31-2.43a4.89,4.89,0,0,1,.95-4.07,7.21,7.21,0,0,1,2.31-2,13.31,13.31,0,0,0,2.93,2.26,18,18,0,0,0,5,2,1.87,1.87,0,0,1,.28-1.76,3.24,3.24,0,0,1,1.89-1.22,4.1,4.1,0,0,1,4.26,1.37c3.15-2.88,8.64-4.33,13.63-3.6a14.59,14.59,0,0,1,9.51,5.11,7.75,7.75,0,0,1,1.12,2,1.6,1.6,0,0,0,1.12-1.85c-.29-2.21-3.25-5.36-.44-6.33,2-.68,3.83,1,4.74,2.45l2.75,4.33,2.37,3.72a3.27,3.27,0,0,0,2-3.44c0-2.73-1.38-6,1.82-7.13a16,16,0,0,1,2.76,7.26l3.35-7.52a13,13,0,0,1,3.53,8.08c2.84.26,5.65-1.71,5.38-3.77,2.23.81,2.91,2.68,3.72,4.48a6.25,6.25,0,0,0,2.94,3.5c2.08,1,4.89.67,7.26,1.26,3.8.93,6.28,4.19,10.31,4.25a6.69,6.69,0,0,0,6.26-4,6.93,6.93,0,0,0,.34-3.06,21,21,0,0,0-.67-3.32l16.91,2.69,3.35.55,19.83,3.17,7.82,1.25c8.84,1.41,17.86,2.83,26.89,2.32C518.6,503,525.31,504.92,526.27,507.53Z"
              />
              <polygon
                class="cls4-19"
                points="583.2 513.14 608.87 510.74 607.51 596.8 583.2 589.17 583.2 513.14"
              />
              <polygon
                class="cls4-20"
                points="806.29 510.34 1154.17 517.02 1154.17 605.58 842.78 605.58 801.43 605.58 806.29 510.34"
              />
              <path
                class="cls4-21"
                d="M963.93,516.74V605s20,4.16,34.52,0V517.75Z"
              />
              <path
                class="cls4-21"
                d="M1006.26,568.42V605s19,5,35.72,0V519.41h-35.72Z"
              />
              <path
                class="cls4-22"
                d="M519.57,553.15v36s40.18,7.2,65.86,0V515.54c0-1.74-2-3.13-4.47-3l-58.38,2.23a2.71,2.71,0,0,0-3,2.17Z"
              />
              <polygon
                class="cls4-23"
                points="579.85 508.34 608.87 505.13 608.87 512.5 517.34 521.14 517.34 514.74 579.85 508.34"
              />
              <polygon
                class="cls4-23"
                points="1154.17 517.88 1058.73 521.14 1026.36 521.94 1026.36 510.74 1077.71 509.94 1153.61 508.34 1154.17 517.88"
              />
              <polygon
                class="cls4-23"
                points="1026.36 510.74 1026.36 521.94 807.57 512.34 807.57 500.33 865.61 502.73 954.91 506.74 1026.36 510.74"
              />
              <path
                class="cls4-22"
                d="M809.72,581.17v23.21s6,3.2-70.59.8-136.4-8-136.4-8l4.79-103.24s-4.79-9.61,26.32-8c4.77.25,160.32,0,177.08,8.81Z"
              />
              <polygon
                class="cls4-19"
                points="808.68 512.49 868.4 515.01 868.4 605.58 807.57 605.58 808.68 512.49"
              />
              <polygon
                class="cls4-19"
                points="835.54 513.57 835.47 528.35 961.61 533.95 961.61 519.1 835.54 513.57"
              />
              <polygon
                class="cls4-24"
                points="835.47 543.55 952.68 545.95 952.68 533.55 835.47 528.35 835.47 543.55"
              />
              <polygon
                class="cls4-25"
                points="870.08 601.98 865.61 601.98 866.73 521.94 871.2 521.94 870.08 601.98"
              />
              <rect
                class="cls4-25"
                x="987.29"
                y="525.14"
                width="4.47"
                height="80.84"
              />
              <polygon
                class="cls4-26"
                points="1127.94 528.35 1127.94 531.55 1009.61 531.55 1008.9 531.53 1008.9 528.32 1009.61 528.35 1127.94 528.35"
              />
              <polygon
                class="cls4-27"
                points="1008.9 528.32 1008.9 531.53 962.73 530.75 843.29 525.94 843.29 522.74 1008.9 528.32"
              />
              <polygon
                class="cls4-24"
                points="835.47 543.55 835.47 588.37 861.15 588.37 862.81 544.11 835.47 543.55"
              />
              <polygon
                class="cls4-28"
                points="870.88 544.28 951.57 545.95 950.45 597.17 870.14 597.17 870.88 544.28"
              />
              <rect
                class="cls4-29"
                x="877.89"
                y="544.35"
                width="2.23"
                height="52.82"
              />
              <rect
                class="cls4-26"
                x="906.92"
                y="545.15"
                width="1.12"
                height="52.02"
              />
              <polygon
                class="cls4-29"
                points="935.94 597.17 932.59 597.17 933.71 545.15 937.05 545.15 935.94 597.17"
              />
              <polygon
                class="cls4-30"
                points="1041.98 605.18 1151.54 605.58 1148.39 518.08 1041.98 521.56 1041.98 605.18"
              />
              <polygon
                class="cls4-31"
                points="1148.64 525.14 1041.98 527.14 1041.98 602.15 1151.5 604.44 1148.64 525.14"
              />
              <rect
                class="cls4-32"
                x="1054.26"
                y="531.55"
                width="8.93"
                height="71.23"
              />
              <rect
                class="cls4-32"
                x="1096.68"
                y="531.55"
                width="2.23"
                height="72.03"
              />
              <rect
                class="cls4-28"
                x="1105.61"
                y="541.95"
                width="24.56"
                height="60.83"
              />
              <polygon
                class="cls4-29"
                points="1131.29 523.54 1132.88 605.51 1130.01 605.5 1127.94 526.74 1041.98 529.2 1041.98 525.94 1131.29 523.54"
              />
              <rect
                class="cls4-27"
                x="1054.26"
                y="541.95"
                width="91.53"
                height="3.2"
              />
              <polygon
                class="cls4-18"
                points="1525.89 640.39 1149.5 612.38 1149.5 609.18 498.36 611.58 661.42 657.2 1525.89 657.2 1525.89 640.39"
              />
              <polygon
                class="cls4-17"
                points="355.48 657.2 284.03 581.97 392.31 583.57 661.34 657.2 355.48 657.2"
              />
              <polygon
                class="cls4-18"
                points="739.47 605.98 476.36 606.57 392.31 583.57 530.73 583.57 739.47 605.98"
              />
              <polygon
                class="cls4-19"
                points="284.03 547.57 284.03 562.76 451.48 564.36 451.48 549.96 284.03 547.57"
              />
              <polygon
                class="cls4-28"
                points="380.28 548.94 380.28 563.68 402.76 563.92 402.76 549.29 380.28 548.94"
              />
              <polygon
                class="cls4-28"
                points="405.79 549.3 405.79 563.92 441.83 564.27 441.43 549.96 405.79 549.3"
              />
              <rect
                class="cls4-33"
                x="419.1"
                y="552.36"
                width="8.93"
                height="12.01"
              />
              <rect
                class="cls4-29"
                x="425.8"
                y="549.15"
                width="2.23"
                height="15.21"
              />
              <polygon
                class="cls4-22"
                points="452.59 549.96 282.92 547.55 282.92 541.15 452.59 542.75 452.59 549.96"
              />
              <polygon
                class="cls4-17"
                points="191.38 586.77 106.55 658 0.5 658 0.5 601.18 67.48 586.77 191.38 586.77"
              />
              <polygon
                class="cls4-17"
                points="96.5 582.77 201.43 584.37 239.38 546.75 208.13 546.75 96.5 582.77"
              />
              <polygon
                class="cls4-34"
                points="203.13 582.69 102.39 580.87 96.5 582.77 201.43 584.37 203.13 582.69"
              />
              <polygon
                class="cls4-16"
                points="1.62 573.97 175.75 546.75 208.13 546.75 96.5 582.77 203.66 584.37 191.38 586.77 67.48 586.77 0.5 601.18 1.62 573.97"
              />
              <polygon
                class="cls4-26"
                points="0.5 545.15 188.03 535.72 188.03 546.75 175.75 546.75 0.5 573.97 0.5 545.15"
              />
              <polygon
                class="cls4-35"
                points="284.03 581.97 282.92 597.17 300.07 598.86 284.03 581.97"
              />
              <polygon
                class="cls4-18"
                points="191.38 586.77 282.92 588.37 282.92 597.17 181.36 595.6 191.38 586.77"
              />
              <polygon
                class="cls4-17"
                points="160.13 658 203.66 609.98 210.29 596.05 282.92 597.17 299.66 598.78 355.48 657.2 160.13 658"
              />
              <path
                class="cls4-35"
                d="M204.88,605.08c-.1.1,100.81,0,100.81,0l-.45,4.9H203.66Z"
              />
              <polygon
                class="cls4-36"
                points="305.24 609.98 346.39 657.24 355.48 657.2 305.24 605.18 305.24 609.98"
              />
              <polygon
                class="cls4-37"
                points="51.85 658 104.31 629.19 123.29 629.19 75.06 658 51.85 658"
              />
              <polygon
                class="cls4-17"
                points="75.29 658 128.87 625.19 147.85 625.19 99.61 658 75.29 658"
              />
              <polygon
                class="cls4-16"
                points="129.99 658 173.52 619.59 152.31 621.19 99.85 658 129.99 658"
              />
              <polygon
                class="cls4-37"
                points="179.1 615.58 198.58 615.58 160.13 658 129.99 658 179.1 615.58"
              />
              <polygon
                class="cls4-6"
                points="106.55 605.18 104.31 629.19 122.34 629.19 128.87 625.19 147.85 625.19 153.59 621.09 173.52 620.4 179.1 615.58 198.08 615.58 203.66 609.98 203.66 587.57 106.55 605.18"
              />
              <polygon
                class="cls4-7"
                points="205.9 587.83 205.9 600.38 203.66 609.98 203.66 587.57 205.9 587.83"
              />
            </g>
            <g id="biblioteca">
              <polygon
                class="cls4-38"
                points="1257.63 77.49 1257.63 117.63 1396.02 77.49 1257.63 77.49"
              />
              <path
                class="cls4-38"
                d="M1068.15,150.09l2.84,30.24,129.16-37.8V77.12h-76.64s-46.84,28.34-52.52,48.77C1071,125.89,1065.31,143.29,1068.15,150.09Z"
              />
              <polygon
                class="cls4-39"
                points="1260.47 114.93 1386.13 77.3 1525.89 77.3 1525.89 641.29 1305.89 630.52 1272.54 271.85 1260.47 114.93"
              />
              <polygon
                class="cls4-39"
                points="1083.77 617.47 1254.09 627.49 1248.41 533.52 1221.44 132.71 1068.15 179.59 1070.99 302.87 1083.77 617.47"
              />
              <polygon
                class="cls4-40"
                points="1051.12 265.05 1039.77 268.07 990.09 227.99 1001.44 224.97 1051.12 265.05"
              />
              <path
                class="cls4-41"
                d="M1001.44,125.89s-2.84,24.2-1.42,40.84l1.42,58.24-11.35,3-2.84-102.05,9.94-3s4.25-21.94,34.06-45.36h7.1S1005.7,102.41,1001.44,125.89Z"
              />
              <polygon
                class="cls4-26"
                points="1069.7 152.88 1066.61 150.34 1198.6 104.58 1201.7 107.13 1069.7 152.88"
              />
              <polygon
                class="cls4-26"
                points="1072.72 127.09 1069.26 124.7 1187.07 76.29 1187.83 75.95 1191.46 78.28 1190.61 78.66 1072.72 127.09"
              />
              <polygon
                class="cls4-26"
                points="1073.83 241.61 1083.77 249.92 1089.44 247.66 1080.93 240.09 1079.51 101.69 1070.99 107.75 1073.83 241.61"
              />
              <polygon
                class="cls4-26"
                points="1089.44 227.99 1089.44 247.66 1080.93 240.09 1079.51 101.69 1086.6 101.69 1089.44 227.99"
              />
              <polygon
                class="cls4-26"
                points="1095.12 236.31 1105.06 244.63 1110.73 242.36 1102.22 234.8 1099.38 84.3 1090.86 90.35 1095.12 236.31"
              />
              <polygon
                class="cls4-26"
                points="1110.73 222.7 1110.73 242.36 1102.22 234.8 1099.38 84.3 1106.47 84.3 1110.73 222.7"
              />
              <polygon
                class="cls4-26"
                points="1116.41 231.01 1126.35 239.34 1132.02 237.07 1123.51 229.5 1119.25 76.74 1110.73 76.74 1116.41 231.01"
              />
              <polygon
                class="cls4-26"
                points="1130.6 209.08 1132.02 237.07 1123.51 229.5 1119.25 76.74 1126.35 76.74 1130.6 209.08"
              />
              <polygon
                class="cls4-26"
                points="1137.7 225.72 1147.64 234.04 1153.31 231.77 1144.8 224.21 1140.54 76.74 1132.02 76.74 1137.7 225.72"
              />
              <polygon
                class="cls4-26"
                points="1151.89 203.79 1153.31 231.77 1144.8 224.21 1140.54 76.74 1147.64 76.74 1151.89 203.79"
              />
              <polygon
                class="cls4-26"
                points="1160.41 219.68 1170.35 227.99 1176.02 225.72 1167.51 218.16 1161.83 76.74 1153.31 76.74 1160.41 219.68"
              />
              <polygon
                class="cls4-26"
                points="1174.6 197.74 1176.02 225.72 1167.51 218.16 1161.83 76.74 1168.93 76.74 1174.6 197.74"
              />
              <polygon
                class="cls4-26"
                points="1184.54 212.11 1194.47 220.43 1200.15 218.16 1191.63 210.59 1185.96 76.74 1177.44 76.74 1184.54 212.11"
              />
              <polygon
                class="cls4-26"
                points="1198.73 190.18 1200.15 218.16 1191.63 210.59 1185.96 76.74 1193.05 76.74 1198.73 190.18"
              />
              <polygon
                class="cls4-26"
                points="1278.92 186.77 1287.44 195.85 1297.38 193.59 1287.44 185.26 1283.18 77.11 1273.25 77.11 1278.92 186.77"
              />
              <polygon
                class="cls4-26"
                points="1295.96 171.65 1297.38 193.59 1287.41 184.45 1283.18 77.11 1293.12 77.11 1295.96 171.65"
              />
              <polygon
                class="cls4-26"
                points="1307.31 179.21 1315.83 188.28 1325.76 186.02 1315.83 177.7 1311.57 77.11 1301.63 77.11 1307.31 179.21"
              />
              <polygon
                class="cls4-26"
                points="1324.34 166.35 1325.76 186.02 1315.8 176.88 1311.57 77.11 1321.51 77.11 1324.34 166.35"
              />
              <polygon
                class="cls4-26"
                points="1338.54 171.65 1347.05 180.73 1356.99 178.46 1347.05 170.14 1342.8 77.11 1332.86 77.11 1338.54 171.65"
              />
              <polygon
                class="cls4-26"
                points="1355.57 158.79 1356.99 178.46 1347.03 169.32 1342.8 77.11 1352.73 77.11 1355.57 158.79"
              />
              <polygon
                class="cls4-26"
                points="1368.34 163.33 1376.86 172.41 1386.8 170.14 1376.86 161.82 1372.6 77.11 1362.67 77.11 1368.34 163.33"
              />
              <polygon
                class="cls4-26"
                points="1385.38 150.48 1386.8 170.14 1376.83 161 1372.6 77.11 1382.54 77.11 1385.38 150.48"
              />
              <polygon
                class="cls4-26"
                points="1402.41 154.26 1410.92 163.33 1420.86 161.06 1410.92 152.75 1406.66 77.11 1396.73 77.11 1402.41 154.26"
              />
              <polygon
                class="cls4-26"
                points="1419.44 141.4 1420.86 161.06 1410.89 151.93 1406.66 77.11 1416.6 77.11 1419.44 141.4"
              />
              <polygon
                class="cls4-26"
                points="1436.47 145.93 1444.99 155.01 1454.92 152.75 1444.99 144.42 1440.73 77.11 1430.79 77.11 1436.47 145.93"
              />
              <polygon
                class="cls4-26"
                points="1453.5 133.08 1454.92 152.75 1444.96 143.61 1440.73 77.11 1450.66 77.11 1453.5 133.08"
              />
              <polygon
                class="cls4-26"
                points="1474.79 136.11 1483.31 145.18 1493.24 142.91 1483.31 134.59 1479.05 77.11 1469.12 77.11 1474.79 136.11"
              />
              <polygon
                class="cls4-26"
                points="1491.83 123.25 1493.24 142.91 1483.28 133.77 1479.05 77.11 1488.99 77.11 1491.83 123.25"
              />
              <polygon
                class="cls4-40"
                points="1070.15 616.47 1054.67 148.97 1067.44 151.24 1070.15 278.12 1083.77 617.47 1070.15 616.47"
              />
              <path
                class="cls4-42"
                d="M1039.06,267.7l3.54,344.49,5-.39v3l21.65,1.59L1054.67,149l9.93,1.77s2.09-29,15.62-40.34,42.58-33.27,42.58-33.27h-85.16s-37.93,27.66-37.42,62.61.51,85.61.51,85.61l51.1,39.33Z"
              />
              <path
                class="cls4-42"
                d="M1253.38,210.22l36.46,418.39,16.05,1.89-45.42-515.57,3.55-1.07V83.7s-9.22-2.83-6.39-6.61H1193.1l4.55,91.46Z"
              />
              <polygon
                class="cls4-41"
                points="1227.12 217.01 1254.09 627.3 1289.57 628.82 1254.09 209.84 1197.31 168.24 1193.05 77.49 1174.6 76.74 1168.93 79.6 1173.62 176.83 1227.12 217.01"
              />
              <polygon
                class="cls4-40"
                points="1173.18 176.57 1198.73 168.24 1254.09 209.84 1227.12 216.65 1173.18 176.57"
              />
              <polygon
                class="cls4-41"
                points="1440.02 77.49 1442.86 95.64 1508.15 149.34 1525.89 289.95 1525.89 119.09 1489.58 86.72 1488.28 77.49 1440.02 77.49"
              />
              <polygon
                class="cls4-40"
                points="1508.15 149.34 1525.89 145.18 1525.18 119.09 1489.7 86.57 1489.29 84.62 1444.38 96.89 1508.15 149.34"
              />
              <polygon
                class="cls4-42"
                points="1487.57 77.11 1488.99 86.2 1525.89 118.71 1525.89 77.11 1487.57 77.11"
              />
            </g>
            <g id="avatars">
              <path
                class="cls4-43"
                d="M173.42,545.9a19,19,0,0,1-3.44.49,4.86,4.86,0,0,1-3.4.53,7,7,0,0,1-1.87-.35,72.48,72.48,0,0,1,.75-10.71,8.71,8.71,0,0,1,.6-3.31c.13-.68.62-.81,1.2-.74a19.11,19.11,0,0,0,8.09-1.24c.34-.11.67-.42,1.05-.07,1.17,4.11,2.5,8.18,3.27,12.39.2,1.52.11,1.36-1.14,2C176.88,545.78,175.08,545.37,173.42,545.9Z"
              />
              <path
                class="cls4-44"
                d="M176.4,530.5a24.1,24.1,0,0,1-7,1.72,5.85,5.85,0,0,1-2-.1c-.51-.12-1-.13-1.27.43a8.44,8.44,0,0,1,.44-2.82c0-1.48.27-1.82,1.63-1.88a5.11,5.11,0,0,0,3.88-1.91,1.72,1.72,0,0,1,.55-.41c1.17-.47,1.43-1.13.87-2.25a2.52,2.52,0,0,1-.3-1,15.14,15.14,0,0,0-2.35-8.06c0-.57.37-.47.71-.37s.69.31,1.06.39c1.26.3,1.94-.32,1.75-1.59a.52.52,0,0,1,.1-.52,1.8,1.8,0,0,1,1.78.52c1.86,1.48,2,3.63,2.06,5.7A48.13,48.13,0,0,0,180,530.29a20.31,20.31,0,0,1,.39,2.46,3.78,3.78,0,0,1-1.57,0c-.58-2.58-1.55-5-2-7.67C176.18,526.89,176.63,528.71,176.4,530.5Z"
              />
              <path
                class="cls4-45"
                d="M164.24,524.7c-1.92-.3-2.32-.88-1.69-2.71a50.58,50.58,0,0,0,1.79-5.89,4.92,4.92,0,0,1,3.85-4.05,11.83,11.83,0,0,1,4.82,8.83,3.75,3.75,0,0,1-.07,1.25,1.72,1.72,0,0,1-.8,1.06c-1.11.65-1.17.86-.59,2a1.44,1.44,0,0,1,.21.53,3.69,3.69,0,0,1-3.9,2c-.68-.21-.64-.7-.46-1.18.34-.91-.12-1.15-.9-1.23S164.87,525.36,164.24,524.7Z"
              />
              <path
                class="cls4-46"
                d="M173.42,545.9a1.89,1.89,0,0,1,1.37-.44c1.59.12,2.9-.76,4.36-1.13.85-.22.31-1,.52-1.44.54,1.26.12,2.51-.16,3.7-1.3,5.52-2.65,11-4.18,16.5a3.43,3.43,0,0,0-.07.56,1.21,1.21,0,0,1-.4.41c-.32.18-.65.52-1,.27a1,1,0,0,1-.19-1.13c.38-4.1.74-8.21,1.18-12.31a11.74,11.74,0,0,1,.74-2.52,3.19,3.19,0,0,0,.17-1.47c-.11-.88-.47-1.46-1.52-1.07A3.21,3.21,0,0,1,173.42,545.9Z"
              />
              <path
                class="cls4-47"
                d="M164.75,546.57a25.8,25.8,0,0,0,5.27-.18c-1.07,1.18-.66,2.7-.88,4.06-.49,3-.23,6-.26,9.06.19,1.78,0,3.57.08,5.35,0,.57-.37.8-.87.86s-.64-.29-.79-.75-.07-1.05-.28-1.55c-.49-3.28-1-6.57-1.48-9.85a12.27,12.27,0,0,1,.12-5.12C165.89,547.45,165.75,546.82,164.75,546.57Z"
              />
              <path
                class="cls4-48"
                d="M174.35,512.23c.25.6.8,1.18.13,1.85a2.1,2.1,0,0,1-2.3.42c-.44-.13-.77-.62-1.32-.44-.83-.14-1.1-.8-1.34-1.48a.66.66,0,0,1,.37-.76c1-.48.9-1.2.48-2.06-.85-1.74-1.57-3.52-1.17-5.53.34.57.43.56,1.3.67,1.13.15,2.25.33,3.38.51a1.17,1.17,0,0,0,1.45-.73c.4.7.08,1.39,0,2.08a12,12,0,0,0-.05,1.34,3.59,3.59,0,0,1-.6,1.57A2.1,2.1,0,0,0,174.35,512.23Z"
              />
              <path
                class="cls4-49"
                d="M175.33,504.68v.68c-.06.5.07.81-.78.44s-2.23-.22-3.34-.49l-.88-.21c-.72-.18-.44.66-.86.9-.38-.6-.07-1.23-.25-1.77.24-2,1-2.9,2.69-3C173.81,501.22,175,502.38,175.33,504.68Z"
              />
              <path
                class="cls4-45"
                d="M173.64,563.2c0,2.09,1.1.22,1.62.45,1.07,1.26,2,2.69,3.89,2.84.46,0,.63.45.35.86a1.34,1.34,0,0,1-.89.68A9,9,0,0,1,173,567a1,1,0,0,1-.37-1.36l0,0A6.51,6.51,0,0,0,173.64,563.2Z"
              />
              <path
                class="cls4-44"
                d="M167,563.42c.38.36.17.88.36,1.29s.08.89.73.77a.83.83,0,0,0,.77-.89s0-.07,0-.11v-5A14.12,14.12,0,0,1,169,564c-.09,1.8.94,2.88,2.07,4,.3.28.78.44.67,1s-.5.61-.92.74a4,4,0,0,1-4.29-1.6,1,1,0,0,1-.11-1.08A6,6,0,0,0,167,563.42Z"
              />
              <path
                class="cls4-50"
                d="M164.24,524.7l3.84.5c.1.37-.17.61-.23.9s-.59,1-.33,1.26,1,.15,1.53,0a3.73,3.73,0,0,0,2.59-1.71.4.4,0,0,1,.55-.13l0,0c.19.14.16.32.05.49a5,5,0,0,1-4.35,2.1c-1.26-.07-1,1.05-1.43,1.56-1.92-.44-2.3-.9-2.31-2.87C164.18,526.14,164.22,525.42,164.24,524.7Z"
              />
              <path
                class="cls4-51"
                d="M169.52,512.58l1.35,1.48a12.7,12.7,0,0,1,2.49,8.31c-.08.23,0,.6-.41.55s-.29-.44-.31-.72a11.13,11.13,0,0,0-3.75-9.22c-.28-.26-.81-.37-.7-.93C168.75,511.9,169.12,512.28,169.52,512.58Z"
              />
              <path
                class="cls4-52"
                d="M174.35,512.23c-.85-.67-1-1.35-.3-2.14.53-.6.66-1.41,1.2-2,.51,1.49,1.31,2.91.93,4.58Z"
              />
              <path
                class="cls4-53"
                d="M178.75,532.77a1.37,1.37,0,0,1,1.57,0,6.41,6.41,0,0,1-.5,4.78c-.67-1-.19-2-.48-2.94-.48.11-.21.69-.59.93Z"
              />
              <path
                class="cls4-54"
                d="M172.64,522.2c.12.2-.09.59.31.63s.25-.33.41-.46c0,.79,1.08,1.23.6,2.27-.3.64-.24,1.37-1.26,1.08-.1,0-.28.23-.42.35,0-.54-.29-.47-.64-.39-.31-.48-.91-.77-.78-1.53.1-.56.12-1,.86-1.09A1.07,1.07,0,0,0,172.64,522.2Z"
              />
              <path
                class="cls4-55"
                d="M176.75,524.2a11.45,11.45,0,0,1,.88-6.06A19.46,19.46,0,0,1,176.75,524.2Z"
              />
              <path
                class="cls4-56"
                d="M166.67,519.7a16.64,16.64,0,0,1,1.66,2.86C166.07,522.82,165.66,522.16,166.67,519.7Z"
              />
              <path
                class="cls4-57"
                d="M171.31,510.73a3.88,3.88,0,0,0,2.16-.14C172.62,511.48,172,511.45,171.31,510.73Z"
              />
              <path
                class="cls4-58"
                d="M810,583c.22,2.63.7,5.22,1.08,7.83a71,71,0,0,1,.59,9.33c0,2,.05,4,.07,6-.63.37-1.43.08-2,.52-.07-1.94-.49-3.83-.75-5.74-.64-4.61-1.54-9.18-2.52-13.73a4.59,4.59,0,0,0-.48-1.45,8.25,8.25,0,0,0-.69,2.63c-1.12,5.72-1.88,11.49-2.45,17.29a7.6,7.6,0,0,1-.16.83,9,9,0,0,0-2,.34,21.61,21.61,0,0,1-.12-5.33c.13-4.43.22-8.87.08-13.3a1.15,1.15,0,0,1-.18-1c.15-.68,0-1.39.21-2.07,1.28-1.08,2.57-2.13,4.36-2.18a38.34,38.34,0,0,0,4.15-.4C809.49,582.46,809.88,582.44,810,583Z"
              />
              <path
                class="cls4-45"
                d="M807.93,566.19a4.1,4.1,0,0,1,1.38.33,25.85,25.85,0,0,1,.41,4.65,14.48,14.48,0,0,1-2.05,6.93,4.58,4.58,0,0,1-.56.75,1.38,1.38,0,0,1-.66.33c-1.17.27-1.23.37-1,1.5a6.24,6.24,0,0,1-3.06,2.63,2.82,2.82,0,0,1-1-.07c-.52-.13-.61-.5-.58-1a7.63,7.63,0,0,0,.07-2.61,1.41,1.41,0,0,0,.28-2l-.09-.11a10.92,10.92,0,0,0-1.41-1.22,2.15,2.15,0,0,1-.93-2.52c.37-1.53.9-3,1.31-4.55a3.94,3.94,0,0,1,3.28-3c.33-.07.66-.16,1-.25.29.39.47.84.78,1.21a3.2,3.2,0,0,0,1.3.94,1.29,1.29,0,0,0,1.37-.14c.39-.32.27-.77.16-1.19C807.9,566.62,807.75,566.42,807.93,566.19Z"
              />
              <path
                class="cls4-59"
                d="M807.93,566.19v.09c.33.61.67,1.32.1,1.87a1.62,1.62,0,0,1-2.11,0,2.75,2.75,0,0,1-1.57-2.15c.48,0,.51-.36.5-.72a6.16,6.16,0,0,0-.65-2.69c.21-.21.07-.49.11-.73s.17-.64.55-.66.58.23.6.65a.89.89,0,0,1,.76-1h.24c.76.06,1.51-.29,2.27,0a10.38,10.38,0,0,1-.28,3.19,1.67,1.67,0,0,1-.69,1.11C807.15,565.59,807.38,565.92,807.93,566.19Z"
              />
              <path
                class="cls4-60"
                d="M816.84,573.71v2.37a23.17,23.17,0,0,1-3.63.09h-2.89c-.54,0-.76-.26-.66-.72a11.13,11.13,0,0,1,.62-2.8,1.61,1.61,0,0,1,1.13-.24h3.81C816,572.57,816.31,573.25,816.84,573.71Z"
              />
              <path
                class="cls4-61"
                d="M800.92,579.66c.4.06.38.36.36.64-.06.73-.09,1.47-.22,2.19-.07.37.12.43.33.54-.12.34-.36.67-.11,1.06.33.57-.3.63-.49.92l-.21,3.2c-1.83-.36-2.33-1.06-2-2.89.21-1.28.47-2.55.67-3.83A2,2,0,0,1,800.92,579.66Z"
              />
              <path
                class="cls4-62"
                d="M815.45,572.52c-.46.33-1,.14-1.47.15h-3.62a4.77,4.77,0,0,1,0-2.8c0-.29.44-.36.73-.31a41.69,41.69,0,0,0,5,.12c.22,0,.46-.07.65.12V571a.42.42,0,0,1-.34.22.9.9,0,0,0-.92.86.66.66,0,0,0,0,.14A.37.37,0,0,1,815.45,572.52Z"
              />
              <path
                class="cls4-63"
                d="M808.75,560.86c-.6.06-1.19.14-1.79.16-1.3.06-1.3.05-1.38,1.31a.83.83,0,0,1-.16-.21c-.12-.32,0-.84-.58-.77s-.25.54-.32.84-.06.4-.33.41a11.69,11.69,0,0,1-.55-2.74,1.21,1.21,0,0,1,.76-1.19,4.2,4.2,0,0,1,2.49-.65c1.36.18,1.87.71,1.94,2.09A6.36,6.36,0,0,1,808.75,560.86Z"
              />
              <path
                class="cls4-64"
                d="M810,583c-.18-.4-.51-.23-.79-.19a28.94,28.94,0,0,1-4.36.38c-.33,0-.81.2-1-.08s.31-.59.57-.81c.46-.38.79-.91,1.36-1.15,1.14.41,1.44-.61,2-1.19.49-.1.76-.29.54-.87a1.65,1.65,0,0,1,.18-1.15c.34-1,.51-1,1.3-.26A41.08,41.08,0,0,0,810,583Z"
              />
              <path
                class="cls4-65"
                d="M809.81,577.63a1.44,1.44,0,0,1-.84-.44c-.12.77-.71,1.32-.3,2.24s-.53.49-.92.6c-.45-.08-.47-.42-.47-.77.43-1,1.14-2,1.55-3a15.66,15.66,0,0,0,1-7.78c-.06-.52-.34-1.05,0-1.57a4.13,4.13,0,0,1,1.35,1.89,1.17,1.17,0,0,0,1.25.85h3.64c.26,0,.57-.11.77.2h-5.61c-.57,0-.72.19-.72.73,0,.73-.08,1.46-.12,2.19-.17.89-.32,1.78-.5,2.67-.11.54,0,.78.64.77h6.32c-.23.33-.58.19-.87.19-1.79,0-3.58.05-5.37,0-.72,0-1,.14-.77.86A2.31,2.31,0,0,1,809.81,577.63Z"
              />
              <path
                class="cls4-66"
                d="M809.8,566.88a16.74,16.74,0,0,1-.12,7.55,15.86,15.86,0,0,1-2.27,4.9c-.47.13-.64,0-.5-.5a14.32,14.32,0,0,0,2.28-11.29c-.06-.31-.37-.74.12-1Z"
              />
              <path
                class="cls4-67"
                d="M800.62,606.84c.57-.72,1.29-.5,2-.34a4,4,0,0,0,1.68.93c.41.12.86.37.85.84s-.55.55-.95.66c-1.37.39-2.39-.41-3.44-1.06C800.42,607.65,800.58,607.2,800.62,606.84Z"
              />
              <path
                class="cls4-68"
                d="M809.67,606.67c.49-.93,1.35-.4,2-.52a4.73,4.73,0,0,0,2,1c.41.09.93.22.89.76s-.55.42-.89.51c-1.45.41-2.67-.26-3.89-.85C809.46,607.43,809.62,607,809.67,606.67Z"
              />
              <path
                class="cls4-69"
                d="M805.87,581.21l-2,1.83,1,.1c-1.32-.08-2.21.81-3.22,1.44-.26.16-.54.29-.81.43,0-.33.7-.4.32-.87.22-.63.84-.74,1.33-1a10.6,10.6,0,0,0,2.92-2.41C805.75,580.65,805.91,580.82,805.87,581.21Z"
              />
              <path
                class="cls4-70"
                d="M805.87,581.21a1,1,0,0,0-.51-.51c-.61-1-.26-1.63.91-1.69a1.8,1.8,0,0,0,.64-.18.46.46,0,0,0,.42.5h.08a1.19,1.19,0,0,0,.34.7,2.88,2.88,0,0,0-.13.31C807.2,581.37,806.87,581.53,805.87,581.21Z"
              />
              <path
                class="cls4-71"
                d="M802.11,572.47c-.83,2.25,1.25,3.24,2,4.8a12.91,12.91,0,0,1-2.79-2.78C801.17,574.1,801.42,573.41,802.11,572.47Z"
              />
              <path
                class="cls4-72"
                d="M802.44,583.11c-.32.51-.92.65-1.33,1-.22-.45-.51-.92.28-1.11Z"
              />
              <path
                class="cls4-73"
                d="M805.28,564.62a4.57,4.57,0,0,0,1.59.67c.19.07.45.09.34.36s-.34.09-.5,0A2,2,0,0,1,805.28,564.62Z"
              />
              <path
                class="cls4-74"
                d="M815.29,572.41c-.1-1.16-.13-1.54,1.49-1.65a1.66,1.66,0,0,1,.41,2.14c-.12.27-.28.52-.42.79C816.18,573.38,815.49,573.18,815.29,572.41Z"
              />
              <g class="cls4-75">
                <path
                  class="cls4-76"
                  d="M502.44,381.1l4.55,3.31c2.77,1.65,1.83,3.75.6,5.75-10.82,17.61-14.48,37.7-20.25,57.12-3.26,10.94-2.84,22.12-4.66,33.11-.69,4.16.78,8.15,1.79,12.1,2,7.76,3.85,15.52,5.18,23.42.28,1.65.17,4.32,3.28,2.57.95-.54,2-1.48,3-.42,1.32,1.45.77,3.22,0,4.72a17.1,17.1,0,0,0-1.18,13.52,5.54,5.54,0,0,1,.64,1.62,2.82,2.82,0,0,1-.7,2.45c-1.44.54-2.92.08-4.38.19-9,.11-17.94.13-26.7-2.24-1.72-.3-3.36-.92-5.1-1.12a62.13,62.13,0,0,1-17.83-5.61c-1.18-.79-2.32-1.89-3.6-.08-.72,1-1.58,1.49-2.51.17-1.29-5-2.55-10.11-1.48-15.31.5-2.47-.52-3.84-2.27-5.09,5.71-7.32,5.45-16.16,6.51-24.72.54-4.35-.22-7.58-4.23-9.78a6.51,6.51,0,0,1-2.8-3.34c-.9-3.29,1-5.81,2.6-8.24a18.84,18.84,0,0,0,3.6-10.32c.31-.72-.78-.21,0-.17.22,0,.28.24,0,.55-2.81,3.38-4.18,8.13-9,9.6-2.3-9-1.46-18.16-.81-27.13.78-10.87,1-21.81,3-32.61,1.41-7.83,2.38-15.79,4.79-23.34,1.72-5.37,6.14-8.7,11.94-9.64,2.56-.42,5.13-.72,7.7-1.06,7.5-1,8.59-2.18,9.43-10.37,2.63-.68,4.73.6,6.85,1.83,1.1,1.35,3.47,1.72,3.27,4.11-.55,1-1.49,1.63-2.08,2.58a2.12,2.12,0,0,0-.14,2.56c.87,1.1,1.66.22,2.32-.35,1.08-.94,2.33-1.45,3.53-.65,3.19,2.12,7,2.34,10.47,3.43C492.94,375.86,498,377.75,502.44,381.1Z"
                />
                <path
                  class="cls4-77"
                  d="M314.06,515.65c-9.05-3.42-18.09-6.85-26.94-10.82-12.44-5.57-19.24-14.37-19.31-28.5-.16-28.91.26-57.82,3-86.59,1.06-11,5.4-21.25,14.34-28.76,6.88,1.7,14,2.17,20.89,3.77a156.52,156.52,0,0,1,16.2,4.32c15.16,5.31,17.41,8.23,17.18,24.26-.45,31.09-1.65,62.13-4.17,93.13-.67,8.23-2.21,16.22-3.61,24.29-.46,2.64-1.21,5.09-3.73,6.55C323.07,518.8,318.38,518.79,314.06,515.65Z"
                />
                <path
                  class="cls4-78"
                  d="M491.14,539.22c1.37-.4,2.42.32,3.5,1,4.05,3.11,3.34,8.69,6.42,12.29-.75,11.7,6,22.22,5.34,33.94-.18,3.24,1.38,6.4,3.08,8.86,1.29,1.86,4.44,2.9,7.13,2.14a4.83,4.83,0,0,1,4.68.81c3.82,5.25,5,11.58,7,17.54,6.17,18.53,12.58,37,16,56.32,2.2,12.3,2.54,24.78,4.51,37.09,1.7,10.65,2.54,21.42,4.34,32.06.41,2.44.92,4.8-1.12,6.8-4.3,2.2-8.57,3.82-12.48-.72a296.72,296.72,0,0,1-8.61-49.41c-2.48-26.56-12.43-50.4-24.39-73.69-4.68-9.11-9.86-17.92-15.16-26.69-2.23-3.68-5.53-4.12-8.95-4.46s-2.9,3-3.33,4.82q-5.75,24.72-12.56,49.18c-1.19,4.29-3,8.41-3.32,12.93-.68,7-3.79,13.15-6.54,19.38-3.52,8-7.71,15.68-11.62,23.49-3.62.78-3.65,4.27-4.74,6.71-8,17.85-12.69,36.75-17.55,55.59-5.52,3.11-10.66,1.64-15.68-1.27,5.83-10.37,7.54-22.11,10-33.41,2.13-9.68,4.87-19.19,7.9-28.49,4.78-14.66,10.09-29.19,15.78-43.58,5.11-13,9.77-26.26,12.51-39.92a73.94,73.94,0,0,0,.61-27.18c-.42-2.42-1.9-3.48-3.56-4.64-6.18-4.3-11.88-9-14.91-16.24-.64-2.1-.71-4.35-1.6-6.39-1.7-10.7-3-21.38,1.51-31.78.87-2.84,1.78-5.62,5.32-2.3-1.55,9.43-.95,10.36,8.16,12.51a91,91,0,0,0,10.37,1.78,17.63,17.63,0,0,1,3.38.54c6.31,1.89,12.83,2.27,19.34,2.74,4.74.34,8.2-.65,8.12-6.37A3.12,3.12,0,0,1,491.14,539.22Z"
                />
                <path
                  class="cls4-79"
                  d="M270.56,740.68c6.13-27.09,14.31-53.5,25.82-78.84,12-26.43,16.94-54.62,20.09-83.19,1.1-10,1.74-20,2.59-30,.68-8.61.63-8.53,7.86-3.8,16.51,10.8,34.38,12.81,53.26,8,2.27-.59,4.47-2.09,6.93-.61.67,10.3-1.23,20.29-3.68,30.2a2.08,2.08,0,0,1-2.36,1.85c-3.12-2.94-6.26-5.85-9.33-8.83s-4.07-2.08-4.9,1.76c-5.26,24-11.8,47.69-22.22,70.11-6.05,13-13.33,25.36-20.86,37.57-12.26,19.85-22,41-30.72,62.57C286.14,750.41,274.83,747,270.56,740.68Z"
                />
                <path
                  class="cls4-80"
                  d="M387.05,552c-17.24,6.93-34.4,5.86-51.51-.52-5.64-2.1-10.22-5.89-15.09-9.32-1.3,2.07.15,4.56-1.39,6.41.15-4.83-.25-9.25-3.71-13.33-2.92-3.44-1-8.23-1.32-12.41-.18-2.4,0-4.81,0-7.22,4.57.5,9.11,1.49,13.75.82a5.6,5.6,0,0,1,4.54-.76c3,1.35,3.73,4.47,5.25,7,4.6,7.55,9.33,9.81,16.51,8a11.7,11.7,0,0,0,7.32-5.57,32.73,32.73,0,0,0,5-16.36c.65-22,4.59-43.57,8.45-65.16,4.22-9.14,4.3-19.14,5.63-28.82,1.43-10.41,3.26-20.81,2-31.5-.88-7.22-3.62-12.72-10.12-16.17-1.15-.61-2.27-1.31-2.5-2.78,3.93-4.88,12.41-5.34,17.7-.23,11.91,11.51,19.19,24.92,16.76,42.38-2.28,16.24-4.5,32.51-6.21,48.82-1.58,15-1.65,29.92,8.61,42.65a11.94,11.94,0,0,1,2.16,4.53c-.52,6.14-3.27,11.3-7.11,16-4.67,1.59-6.75,5-8,9.72-1.64,6.11-2,12.42-3.64,18.49C389.57,548.68,389.86,551.27,387.05,552Z"
                />
                <path
                  class="cls4-81"
                  d="M370.25,364.34c13.14,5.33,14.95,13.68,14.12,28.92-.77,14.05-3.29,28-5.14,42-.4,3.07-.68,6.3-3.3,8.57a5.74,5.74,0,0,1-6.75.42c-2.56-3.54-1.79-7.56-1.25-11.35,1.95-13.85,3.57-27.73,5-41.64a37.24,37.24,0,0,0-1.67-14.9c-.49-1.57-1.55-3.32-3.65-2.52-1.87.72-1.27,2.46-.86,3.88,3.65,12.65,1.92,25.58,1.43,38.34-.44,11.14-.7,22.33-1.79,33.46-1.21,12.22-1.15,24.55-2.89,36.7-1.7,11.9-8.13,20.62-19,25.94-1.51.73-2.92,1.65-4.37,2.49a14.18,14.18,0,0,1-7.89,1.77l-4.38.05c3.7-7.62,4.65-16,5.34-24.14q1.85-22.15,2.7-44.44c.74-20.23,1.69-40.45,2.17-60.69.17-7.41-3.42-11.27-9.06-13.72a121.57,121.57,0,0,0-37.08-9.23c-2.71-.26-5.16-.76-6.7-3.27,7.13-5.4,15.44-6.14,23.93-5.86,3.24.11,5.18-.32,6.73-3.86,3-6.78,11.14-8.76,20.6-5.17a38.74,38.74,0,0,0,12.39,2.6c-1.78,3.52-.52,6.93.29,10.4,1.38,5.88,3.92,7.37,9.57,5.37C362.54,363.1,366.37,361.41,370.25,364.34Z"
                />
                <path
                  class="cls4-82"
                  d="M500.21,552.4c-4.45-2.89-3.22-8.36-5.57-12.21v-2.31c3.47.12,4.23,3.77,7.28,5.31-2.5-5.6-7.47-10.22-4.51-17-2.92,3.71-.77,8.09-2.76,11.7-4.14-4.16-2.3-8.84-1.1-13.42.49-1.9,2.32-3.38,1.94-5.74-3-.3-2.36,3.28-4.29,4.14a7,7,0,0,1-3-5.17c-.93-9.57-3.73-18.73-6-28-2.51-10.22-.29-20.33,1-30.22,2-15.51,7.7-30.27,12-45.31A86.45,86.45,0,0,1,506.84,389a3.8,3.8,0,0,0,.15-4.63c10.64,5.78,15.34,8.75,12.58,22.42-1.59,7.85,1,14.88,4.45,21.84,4,8,5.09,16.21-.29,24.29-2.94,4.4-7.41,6.21-12.13,7.29-2.83.64-3.42,1.88-3.55,4.51-.9,16.89.45,33.55,7.14,49.17,2.93,6.85,4.75,13.44,4,20.77a7.5,7.5,0,0,1-1.83,1.17c-1.11.45-2.28.76-3.39,1.22-3,3.23.59,6.09.5,9.15a3.18,3.18,0,0,1-.78,2.28C509.75,551.6,505.32,553.24,500.21,552.4Z"
                />
                <path
                  class="cls4-83"
                  d="M513.22,547.79c.15-.67.31-1.33.46-2-.49-3.3-2.23-6.61,0-9.91l3.45-.92c2.51,2.94-.36,6.94,2,9.92,5.79,14.49,11.74,28.91,17.34,43.48,8.81,22.89,17.55,45.83,22.45,70,1.85,9.15,2,18.48,2,27.78a424.11,424.11,0,0,0,3.3,56.77c-3.19,4.08-7.28,5.64-12.36,4.4,1.63-5.06-1.12-9.71-1.55-14.58-1.12-12.86-4-25.57-4.94-38.44a258.68,258.68,0,0,0-5.62-35.54c-2.74-12.92-7.48-25.17-11.4-37.69-2.37-7.58-5.23-15-7.88-22.51-1.33-3.31-.46-6.65,0-9.93,1.14-7.71,1-15.18-2.66-22.36a102.5,102.5,0,0,1-4.57-11.44C512.4,552.49,511.94,550.14,513.22,547.79Z"
                />
                <path
                  class="cls4-84"
                  d="M370.25,364.34c-4.32-.41-8.42-.19-12.4,2.1s-9.41-.93-10-5.61a14.09,14.09,0,0,0-.51-3.29c-1.26-3.28-2.39-6.46,1.48-8.85l1.29-1.25c3.13-1.93,6.09.17,9.12.42,6.25.53,12.44,1.85,18.77,1.21a6.73,6.73,0,0,1,5.59,1.79c1,1.32,2.49,2.5,3,4,4.23,12.3,15.1,18.53,24.19,26.23,6.59,5.59,10.38,11.76,9.76,20.62-1.76,25.44-3.52,50.89-4.09,76.39,0,2-.67,4.1.56,6-.64,7.47-4.17,13.58-9.06,19-3.66-7-9.2-13.12-10.9-21.13-1.94-9.2-1.4-18.54-.47-27.76,1.38-13.8,3.35-27.54,5.09-41.3a118.89,118.89,0,0,0,1.25-16.54c-.17-13.76-8.44-23.16-17.2-31.86C381.83,360.64,375.48,360.48,370.25,364.34Z"
                />
                <path
                  class="cls4-85"
                  d="M350.35,341.94c-.32-6.76-2.53-12.67-7.52-17.47a27.48,27.48,0,0,1-8.59-21.07c0-1.68,0-3.36-.11-5-1-15.77,6.56-25.1,22.28-27.3,2.18-.07,5.23-2.17,4.9,2.85-.1,1.59,2.89,1.92,4.65,2.38,5,1.32,10.1,2.36,15,4.24,10.39,4,13.59,9.8,11.41,20.8-1.07,1.91-2.89,2.78-4.83,3.48-6.06,1.5-11.69,4.55-18.07,5-2.49.17-2.84,1.8-2.26,4,1,3.72,4.16,5.49,6.75,7.81,2.29,2.46,2.37,5.29,1.43,8.3-.38,1.24-.78,2.47-1.17,3.7-3.22,10.24-11.74,14.23-21.91,10.25A3.81,3.81,0,0,1,350.35,341.94Z"
                />
                <path
                  class="cls4-86"
                  d="M436.47,570.37a46.47,46.47,0,0,0,17,16.42c1.25.69,2.11,1.63,1.91,3.1-.54,4,1.29,7.72,1.13,11.62a121.77,121.77,0,0,1-7.19,37c-3.81,10.46-6.94,21.13-11.45,31.37-3.63,8.26-6.2,17-9.05,25.6-4,12.13-7.9,24.27-10.4,36.85-1.83,9.25-4.54,18.33-6.88,27.48-.58,2.24-1.94,3.57-4.42,3.36-3.93,1.34-7.16.9-8.89-3.44,5.23-28.86,10.17-57.79,21.5-85.11,4.61-2.62,4.49-7.72,5.26-11.81,1-5.2,4.56-10.37,1.54-16A27.75,27.75,0,0,1,429,633.16c1.41-1.49,3-2,3.84.32,3.47,9.59,6.32,19.28-.32,28.73-2.31,3.28-1.62,6.56-.6,10.06.05-6.25,3.76-10.8,6.19-16,3.91-8.4,7.5-17.44,8.5-27,.13-1.3-.2-2.75.57-3.83,6.46-9,4.11-19.34,4.52-29.26.14-3.3-1.55-5.5-3.92-7.6-4.17-3.68-8.64-7.17-11-12.49C436,574.16,434.65,572.37,436.47,570.37Z"
                />
                <path
                  class="cls4-87"
                  d="M387.05,552c3.11-8.41,3.08-17.49,5.66-26,1.42-4.72,3.49-8.21,9-8.38a1.61,1.61,0,0,1,1.76.14c4.07,4.64,4.92,10.32,4.94,16.16,0,17.62-3.62,34.78-7,52a35.35,35.35,0,0,0,.92,16.51c1,3.8,3.6,5.08,7.17,4.61,5.73-.75,11.24-2.62,16.92-3.7,2.72-.53,3.53-2.75,3.61-5,.42-13.15,3.18-26.19.77-39.49-1.35-7.48-.82-15.26-.08-22.88.39-4.09.75-8.15.75-12.26,0-8,0-8-7-9.89-1.32-1.68.25-2.09,1.21-2.77,1.79-.58,3.57-1.38,5.4-.12,2.21,0,4.81-.49,4,3.18-1.39,6.12.18,12.17.39,18.24-1.22,10.89-2.24,21.77.12,32.64a106.13,106.13,0,0,1-1.64,39.9,5.45,5.45,0,0,1-3.4,2.64c-6.7,2.14-13.68,3.07-20.5,4.69a9.08,9.08,0,0,1-6.45-1.06c-2.39-2.33-5.64-2.69-8.6-3.66-11.75-3.83-12.84-5.22-12.8-17.37,0-2,.43-4.1-1.09-5.83,3.26-5.6,2.5-12,3.7-18.06C385.69,561.49,386.3,556.75,387.05,552Z"
                />
                <path
                  class="cls4-88"
                  d="M446.64,318.29c-3.24-16.92,3.88-28,19.64-30.43,2.17-.58,4.26-.89,4.27,2.35,0,4.22,2.7,5.81,6.27,6.65,4.9,1.17,9.75,2.5,14.74,3.35,7,1.18,11.94,5,14.58,11.67,1.07,2.71,1.41,5.43-.55,8a9,9,0,0,1-4.71,3.08c-14.34,2.47-28.72,4.36-43.31,2.55-1.67-.2-3.32-.46-5-.7C448.75,324.25,446.62,322.29,446.64,318.29Z"
                />
                <path
                  class="cls4-89"
                  d="M387,303.67l4.61-2.12c2.92-2.23,5.93-4.07,9.82-2.53a73.86,73.86,0,0,1,1,33,52.83,52.83,0,0,0-.82,12.17c.18,5.24-2.29,7.19-7.13,6.52-3.1-.43-6.16-1.17-9.22-1.87-2.13-.5-2.15.51-1.65,2-7-.78-14,.29-21-1-4.18-.74-8.3-1.77-12.48-2.46.07-1.83.14-3.67.22-5.5,5.61,2,11.32,1,17,.62.72-.05,1.74-.19,2.07-.66,3.06-4.33,3-9.81,5.3-14.46,1.23-2.51-1.17-4-2.36-5.79-2.49-3.19-2.51-6.14,1.08-8.49,3-2,6.1-.58,8.45,3.64.69,1.25.88,3.29,2.62,3.22,2.19-.08,1.94-2.39,2.42-3.88a11.89,11.89,0,0,0,.22-7.13C386.67,307.27,385.75,305.49,387,303.67Z"
                />
                <path
                  class="cls4-90"
                  d="M478,730.59c2.52,4.25,6.33,5.73,11.17,5.84,6.54.15,13,.13,19.33-1.79,5.11-1.55,10.06-1.13,14.38,2.44-.22,8.61-6.9,16.78-16.47,19.06-12.64,3-25.46,5.26-38,8.72-3.74,1-6.51-.62-8.24-4-1.74-7.74-1.1-15.61-1.27-23.44,3,.18,5.53,2.73,9,1.59,4-1.33,7.87-2.51,8.6-7.51C476.52,730.69,477,730.15,478,730.59Z"
                />
                <path
                  class="cls4-91"
                  d="M446.64,318.29c.79,2.86,2.76,4.07,5.62,4.7,11.86,2.65,23.73,1.48,35.61.35,4.56-.44,9.1-1.07,13.65-1.61.31,6.24-3.17,11.26-5.6,16.56-1.11,2.41-3.15,2.38-4.57-.2-.36-.65-.59-1.36-1-2-.78-1.31-1.68-2.66-3.48-2a2.59,2.59,0,0,0-1.35,3.31c2.2,8.18-2.5,14.74-5.16,21.7-1.73,4.49-5.28,5.47-10.49,3.91l-6.44-2.34c-.67-4.95-3.34-9-6.28-12.77C450.4,339.18,446.66,329.41,446.64,318.29Z"
                />
                <path
                  class="cls4-92"
                  d="M469.9,363.05c6.4.3,9.93-2.92,11.26-9,1.22-5.6,5.63-10.61,2.49-17-1-2.06.31-4.48,2.91-5.19,2.33-.63,4,.57,4.91,2.67.72,1.63,1.28,3.32,2.31,6,2.87-7,5.3-12.88,7.74-18.79l3.24-2.42c5-2.92,6.54-2.69,8.76,1.33-1.89,3.3-.57,6.9-.66,10.29-.26,10.4-1,20.66-3.48,30.81-1.68,6.93-2.77,7.87-9.93,6.16-2-.48-3.94-1-5.92-1.51-4.66.68-9.24,2-14,1.7-2.15-.14-4.43.17-6.14-1.63C472.5,365,469.83,365.43,469.9,363.05Z"
                />
                <path
                  class="cls4-93"
                  d="M565.3,761.66c1.9,1.52,1.14,3.24.34,5.24a4.68,4.68,0,0,1,6.54-1c.13.1.26.2.38.31,1.67,1.61,4.25-1.56,4.82,1.56,4.3-5.28,11.22-3.52,16.6-6.11,4.73-2.28,8.64-.46,10.24,5,.83,5.4-3.16,8.14-6.44,11-4.4,3.9-10,5.6-15.52,7.23-3.73,1.1-7.46,2.23-11.22,3.25-5.42,1.34-10.56,4.26-16.46,3.06-2-.29-2.85-2-4-3.35-1.53-7.06-3.93-14-2.13-21.42C555.19,768.79,560.37,765.67,565.3,761.66Z"
                />
                <path
                  class="cls4-94"
                  d="M286.46,767.34c7,.74,13.83,1.3,20.8-.68,4.05-1.14,8.41-.58,11.7,2.84.47,11.17-8.64,14.35-16.16,16.88a68.48,68.48,0,0,1-35.05,2.78c-5.43-1-8-3.55-8.44-8.34,2-6.05,3.36-12.33,6.84-17.81a2.33,2.33,0,0,1,2.43.94C273.75,769.11,279.91,769.31,286.46,767.34Z"
                />
                <path
                  class="cls4-95"
                  d="M445.11,702.87c0-1.25-.47-2.46.25-3.76,6.95-12.58,12.41-25.86,17.91-39.11q5,25.77,10.07,51.54c-5.57,5.93-12.95,7.16-20.51,7.78a2.82,2.82,0,0,1-2.84-2.24Q447.55,710,445.11,702.87Z"
                />
                <path
                  class="cls4-96"
                  d="M513.52,320.64c-2.51-3.16-5.71-1.77-8.76-1.33,2.48-7.64-3.79-16.52-13-17.65-5.77-.71-11.22-2.51-16.83-3.7-3.71-.79-6.82-2.83-5.86-7.35.62-2.9-1.28-2.42-2.77-2.75,16.37-4.1,31.39-1.27,44.51,9.42,9.18,7.48,11,18.59,5.12,27.36Z"
                />
                <path
                  class="cls4-97"
                  d="M390.35,791c2.89-4.48,4.54-9.8,9-13.17,3.82,4.53,8.37,6.35,14.13,3.9a2.65,2.65,0,0,1,2.61.27c-.1.88.09,2.3-.36,2.55-3,1.63.14,2.15.47,3.14-.7,3,.49,4,3.41,3.43,1.42,0,.68,3.16,3.92,1.73,2.86-1.26,7.14.8,10.81,1.28,3.08.41,5.32,1.68,5.68,5s-1.85,4.63-4.32,5.75a21.85,21.85,0,0,1-2.64.83c-14.57,4.3-28,.58-41.05-5.84C388.3,797.57,389.34,794.29,390.35,791Z"
                />
                <path
                  class="cls4-98"
                  d="M403.55,611.08c10.05-.64,19.65-3.61,29.42-5.65.58.5,1.17,1.12,1.1,1.84-.8,8.69-.21,17.62-4.18,25.8-1,4.84-2.31,9.64-2.31,14.64.13,1-.22,1.39-1.22,1C420.16,635.34,411.37,623.5,403.55,611.08Z"
                />
                <path
                  class="cls4-99"
                  d="M401.43,299c-3.43.23-6.25,2.8-9.82,2.53-.23-5.29.92-10.81-3.41-15.3-3.57-3.69-8.38-4.44-12.84-6-5-1.76-10.58-1.94-15.34-4.65-1-.58-2.91-.75-2.41-2.46.2-.67,1.74-.94,3.1-1.61l-4.3-.46c10.36-2.77,20.16.45,30,2.81,2.35.56,4.67,1.74,7,1.73,6.2,0,9.73,3.15,11.36,8.71S406.49,295,401.43,299Z"
                />
                <path
                  class="cls4-100"
                  d="M402.81,517.73l-1.15-.11L408,503.13l9.06-19,10.41-19.23c3.15-3.28,5.23-7.52,9.46-10.54,1.1,3.33,1,5.93-1,8.76s-4.2,6.05-4.95,9.75c-2.5,9.51-7.9,17.79-11.41,26.88a43.38,43.38,0,0,1-3.63,7.93c-1.85,3.14-1.42,5.3,1.75,7-.79,2.5-3.1,2.73-5,2.65C409.34,517.16,406.1,517.88,402.81,517.73Z"
                />
                <path
                  class="cls4-101"
                  d="M450,717.08c2.33,2.15,4.86.91,7.33.41a66.28,66.28,0,0,0,16-6c.7,5.22,5.48,9.84,2.3,15.64-5.1,4.83-10.81,7.82-18.12,6-1.23-.24-3,0-3.38-1.34C452.75,726.88,448.16,722.87,450,717.08Z"
                />
                <path
                  class="cls4-102"
                  d="M270.56,740.68c6.85,4.41,14,7.7,22.48,6.72-1.65,5.18-.59,11.6-6.71,14.75-6.7,1.45-12.81.65-17.72-4.69-3.77-3.21-1.42-6.71-.48-10.14C268.75,745,268.8,742.54,270.56,740.68Z"
                />
                <path
                  class="cls4-103"
                  d="M398.27,759.71c2.5,2.34,5.63,3.07,8.89,3.44,5.06,1.94,10.33,2.21,15.66,2,.1,9-.48,9.9-6.57,10.34-5.34.94-10.64,1.34-15.67-1.32C395.34,770.07,395.41,765.11,398.27,759.71Z"
                />
                <path
                  class="cls4-104"
                  d="M551.8,747.3a42.54,42.54,0,0,0,12.36-4.4c1.88,4.71,4.67,9.51-1.36,13.42-4.94,2.24-10.3,2.52-15.54,3.36-7.42-1.1-7.37-6.84-7.67-12.36C543.66,749.54,547.75,748.43,551.8,747.3Z"
                />
                <path
                  class="cls4-105"
                  d="M460.11,760.82c3.76,3.19,7.57,2.87,12.22,1.51a215.34,215.34,0,0,1,26.47-5.8c11.94-1.89,20.92-6.91,24-19.45,2.46,2.41,1.84,5.18.31,7.53-3.82,5.85-8.65,10.67-15.59,12.71-3,.89-6.19,1.26-9.19,2.21-6,1.89-12.35,1.25-17.94,6.21-3.55,3.16-10.44,3.6-16.06,2.94C459.75,768.14,460.45,764.05,460.11,760.82Z"
                />
                <path
                  class="cls4-106"
                  d="M259.29,780.82c2.56,7.4,9.46,7.58,15.15,7.69,14.63.29,29.19-.44,41.1-11.16,2.66-2.4,1.38-5.67,3.42-7.85,2.8,4.48.42,7.68-2.69,10.63-8.83,8.36-19.92,10.18-31.43,11-2.36.16-5.11-.75-6.83,2.45-.88,1.65-15.51-1.17-18-3.26C256.63,787.44,257.43,784.14,259.29,780.82Z"
                />
                <path
                  class="cls4-107"
                  d="M473.36,366.46c5.16-.21,10.36.49,15.48-.91,1.5-.41,3.35-.62,4.69.84-.17,6.81,4.3,10.8,8.91,14.71-5.11-1.85-10.35-3.42-15.29-5.64-3.48-1.57-8-.16-10.69-3.86-.48-.66-1.47-.2-1.74.59-.89,2.57-2.11,4.3-4.59,1.54-2.26-2.52-1.29-4.79,1.15-6.6A6.94,6.94,0,0,1,473.36,366.46Z"
                />
                <path
                  class="cls4-108"
                  d="M547.26,759.68c4.67-3.5,10.12-3.35,15.54-3.36-.22,2.27,1.32,3.72,2.5,5.34-2.51,5.19-6.7,7.34-12.41,7.27a4.74,4.74,0,0,1-4.43-2.54Z"
                />
                <path
                  class="cls4-109"
                  d="M457.52,733.13c6.72.08,12.25-3.46,18.12-6l2.31,3.41c.2,4.89-2.42,7.68-6.88,8.9s-9,3.22-12.23-2.11Z"
                />
                <path
                  class="cls4-110"
                  d="M268.61,757.46c5.53,3,11.66,3.72,17.73,4.69l.12,5.19c-4.21,5.75-15.55,2.62-20.33-4.33C267.07,761.21,268.49,759.63,268.61,757.46Z"
                />
                <path
                  class="cls4-111"
                  d="M400.58,774.19c5.23.35,10.57-.61,15.67,1.32,0,2.17-1.38,4.32-.12,6.51a13.32,13.32,0,0,1-14.09.64c-2.06-1-3.2-2.41-2.65-4.81C399.75,776.63,400.18,775.41,400.58,774.19Z"
                />
                <path
                  class="cls4-112"
                  d="M570.88,786.64c6.18-1.89,12.46-3.52,18.52-5.74,7-2.54,13-6.35,14.82-14.32,2.69,3.43-.39,5.76-1.92,8A24.41,24.41,0,0,1,591,783.24c-7,2.82-14.16,5.24-21.25,7.83C568.86,789.27,569.75,787.92,570.88,786.64Z"
                />
                <path
                  class="cls4-113"
                  d="M392.59,799.11c4.89,1.74,9.84,3.32,14.65,5.24,8.5,3.38,17.15,2.71,25.86,1.42-5.73,4.05-12.59,2.92-18.71,2.82-7.32-.12-15-1.3-21.71-5.1C391.65,802.05,391.33,800.6,392.59,799.11Z"
                />
                <path
                  class="cls4-114"
                  d="M426.36,648.74l1.22-1c5.31,3.07-1.12,6.54.27,10.35,1,2.79-1.72,6.91-2.63,10.47-.77,3-1.26,6.18-5.45,6.07C422.16,666,425.66,657.74,426.36,648.74Z"
                />
                <path
                  class="cls4-115"
                  d="M570.88,786.64a7.26,7.26,0,0,1-1.14,4.44l-8.92,3.48c-3.46.49-3.33.44-4.55-2.51-.27-.65-2.25-.23-2.24-1.85C560,790.66,565.26,787.79,570.88,786.64Z"
                />
                <path
                  class="cls4-116"
                  d="M392.59,799.11l.09,4.38c-5.46-.67-6.8-2.61-5-7.64a34.1,34.1,0,0,1,2.67-4.85C390.68,793.83,389.4,797.09,392.59,799.11Z"
                />
                <path
                  class="cls4-117"
                  d="M554,790.2c-.74,1.95,5.48-1.08,2.29,3.35-.8,1.13,3,.22,4.5,1-7.79,3.73-9.93,2.32-10.23-6.75Z"
                />
                <path
                  class="cls4-118"
                  d="M519.1,544.89c-2.54.55-2.13-1.29-2.12-2.7,0-2.41.11-4.82.17-7.23l2.06-.26C519.17,538.1,519.14,541.49,519.1,544.89Z"
                />
                <path
                  class="cls4-119"
                  d="M419.65,791.14c-1.11,1.72-1.8,2.67-3.88.44-1.93-2.06-1.46-2.78.47-3.87A8.41,8.41,0,0,1,419.65,791.14Z"
                />
                <path
                  class="cls4-120"
                  d="M491.14,539.22c.15,9.74.14,10-9.43,9.64-6.57-.22-13.36.36-19.42-3.19-2.15-3.26-2.72-6.32,1.17-8.78C472.56,539.17,481.88,538.88,491.14,539.22Z"
                />
                <path
                  class="cls4-121"
                  d="M458.86,545.59c-5.2-.92-10.49-1.52-15.58-2.85-5.25-1.37-6.47-8.34-2.53-12.77,5.74,2.52,11.56,4.8,17.79,5.85C461.32,539,460.21,542.29,458.86,545.59Z"
                />
                <path
                  class="cls4-122"
                  d="M458.86,545.59c-.1-3.25-.21-6.5-.32-9.77l4.92,1.07c-2,2.71-.78,5.86-1.17,8.79Z"
                />
                <path
                  class="cls4-114"
                  d="M429.89,633.07,433,605.43c1.3-13.48,2.47-27,2.56-40.52,1.54,1.61.59,3.65.93,5.46,1.1,8.38,7.48,12.94,13.27,17.72,2.44,2,3.7,3.9,3.5,7-.5,7.78,1,15.65-1.11,23.35a27.88,27.88,0,0,1-2.92,6.38c-2.07,3.64-1.32,8.27-2.61,12.4-2.09,6.68-5.65,12.91-6.22,20.07a3.22,3.22,0,0,1-1.8,2c-4.24,1.82-4.82,5.27-4.41,9.25a1.75,1.75,0,0,1,0,.56c-.41,2.48-.37,6.77-2.25,6.76-3.7,0-1.44-4.07-2.27-6.24-1.59-4.15,0-7.12,3-9.85,2.45-2.23,2.31-5.71,2.34-8.35a52.33,52.33,0,0,0-3.58-18.51A5.75,5.75,0,0,0,429.89,633.07Z"
                />
                <path
                  class="cls4-123"
                  d="M513.22,547.79c.51,6.44,3.54,12.07,6.16,17.73s4,11.48,3.23,17.68c-.6,5.13-1.41,10.23-2.14,15.35-1.05-.12-2.86-.65-3.05-.29-3.6,6.52-4,.72-5.28-1.42-1,1.1-.88,3.37-2.81,3.13-1.75-.21-.85-2.19-1.41-3.21-5-9.15-1.49-20.15-6.69-29.45-2.4-4.29-.78-9.9-1-14.91C504.54,550.84,509.19,550.2,513.22,547.79Z"
                />
                <path
                  class="cls4-124"
                  d="M332.19,516.42a12.89,12.89,0,0,1,6.84-2.13c2.89.48,2.67,3.26,3.68,5.08,1.78,3.19,3.67,6.4,7.85,6.12,4.36-.29,7.06-3.17,8.4-7.16a44.5,44.5,0,0,0,1.85-10.43c1.67-19,3.63-38.08,5.68-57.09.27-2.57.43-5.25,2.75-7.05l6.69.07c-1.58,10.84-3,21.71-4.8,32.51a232.52,232.52,0,0,0-3.05,31.05,42.38,42.38,0,0,1-3.83,16.15c-3,6.73-8.29,9.54-15,9.59-6,0-9.6-4.39-12.66-9C334.92,521.71,333.64,519,332.19,516.42Z"
                />
                <path
                  class="cls4-125"
                  d="M369.24,443.76c-3,17-4.49,34.1-5.94,51.26-.56,6.61-.48,13.29-1.78,19.89-1.47,7.45-5.43,12.58-11.1,12.78-4.48.17-8.46-4.29-10.37-11.52a9.17,9.17,0,0,0-1-1.88c.71-2,2.4-2.6,4.15-3.39,11.79-5.29,18.22-14.71,19.14-27.33,1.5-20.59,2.91-41.19,3.85-61.83.52-11.36.61-22.7.77-34.06.05-3.36.06-6.75-2-9.66-1.9-2.61-1.78-4.95,1.21-6.46,3.28-1.66,5.58.12,6.57,3.06,2,6.06,2.21,12.33,1.62,18.73-1.26,13.88-3,27.69-5.07,41.48C368.75,437.74,369.21,440.78,369.24,443.76Z"
                />
                <path
                  class="cls4-126"
                  d="M331.13,358.06c2.53-2.72,6.57-5.73,10-5.08,2,.38,1.89,2.25,2.34,4.31a3,3,0,0,1-4.09,3.61C336.8,360,334.22,359.12,331.13,358.06Z"
                />
                <path
                  class="cls4-127"
                  d="M331,349.62c2.61.52,10.56,3.1,10.09,3.36-3.43,1.88-4.19,4.29-6.73,5.6-.74.38-13.48-2.35-14.23-3.16-.94-1-.14-2,.52-2.92C323.47,348.78,328.4,349.09,331,349.62Z"
                />
                <path
                  class="cls4-76"
                  d="M494.68,537.89a19.75,19.75,0,0,1,2.51-15.28c.92,7.63,1.45,15.28,7.46,21.57-6,1-7.13-3.94-10-6.3Z"
                />
                <path
                  class="cls4-128"
                  d="M513.75,535.89v9.91c-2.43-2.12-1.69-5.39-2.83-8C510.07,536,512.24,535.83,513.75,535.89Z"
                />
                <path
                  class="cls4-129"
                  d="M387,303.67c2,5.3,2.89,10.61.67,16.13-.67,1.66-1.11,3.13-3.26,3.05-1.87-.08-2.48-1.3-2.86-2.86-.22-.9-.59-1.76-.88-2.63-.93-2.81-2.71-4.71-5.78-3.71-2.58.84-3.65,3-2.8,5.81a13.4,13.4,0,0,1,.29,2.19c-1.8-.94-3.77-1.71-4.83-3.56-1.44-2.53-3.37-5.31-2.25-8.18s4.27-1.18,6.47-1.77C376.88,306.77,381.93,305.18,387,303.67Z"
                />
                <path
                  class="cls4-130"
                  d="M402.81,517.73c2.37-1.9,4.79-2.75,8-1.79a7.5,7.5,0,0,0,6.52-1.53c1.83-2.29,4-3.07,6.59-1.28a4.66,4.66,0,0,1,1.12.08c2.88.93,6.64-2.35,8.26,0,1.31,1.91-.32,5.69-.19,8.62.39,9.13-1.73,18.12-1.26,27.28.27,5.38.15,10.73,1.8,16,1.38,4.39-.82,8.74-.77,13.22A108.71,108.71,0,0,1,431,601.94c-.47,2.21-1.31,3.23-3.64,3.18-5.64-.1-10.8,2.26-16.19,3.45-6.73,1.49-8.71-.67-10.87-7.1-3.73-11.09,1.12-21.15,2.42-31.51s3.09-20.42,3.71-30.84A45.24,45.24,0,0,0,402.81,517.73Z"
                />
                <path
                  class="cls4-131"
                  d="M423.92,513.13l-6.59,1.28c-5.21.63-6.06-1.17-3.37-5.54a103,103,0,0,0,4.56-9.25A76.15,76.15,0,0,1,426,511.87Z"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </>
  );
};

export default Libre;
